import classes from './Kiosk.module.css';
import logo from "../../../store/Diplomat/logo02.png"
import { React, useEffect, useLayoutEffect, useRef, useState } from "react";
import { MapContainer, TileLayer, CircleMarker, Tooltip } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { path, assetsBaseUrl } from "../../../routes";
import {CircularProgress} from "@mui/material";
import axios from "axios";
import cloud from "../../../store/cloud-icon-17.png"
import bck1 from "../../../store/Diplomat/footer_slideshow/4dc6f436-2685-4cdc-a134-a9df74068765LHP_5507h.jpg"
import conferenceFloorplan from "../../../store/Diplomat/floorplan.png"
import btn1 from "../../../store/Diplomat/Icons/01-Restaurant.jpg"
import btn2 from "../../../store/Diplomat/Icons/01-Rooms.jpg"
import btn3 from "../../../store/Diplomat/Icons/01-Conferences.jpg"
import btn4 from "../../../store/Diplomat/Icons/01-Services.jpg"
import btn2_1 from "../../../store/Diplomat/Icons/02-Lobby-bar.png"
import btn2_2 from "../../../store/Diplomat/Icons/02-BULL-BONITO.png"
import btn2_3 from "../../../store/Diplomat/Icons/02-Restaurant-KATSURA.jpg"
import btn2_4 from "../../../store/Diplomat/Icons/02-Loreta-restaurant.jpg"
import btn2_5 from "../../../store/Diplomat/Icons/02-Roof-terrace.jpg"
import btn2_6 from "../../../store/Diplomat/Icons/02-Room-service.jpg"
import btn2_7 from "../../../store/Diplomat/Icons/02-Catering.jpg"
import room1 from "../../../store/Diplomat/rooms/8af18c67-32cc-498e-b551-64576c7f2ffa.jpg"
import room2 from "../../../store/Diplomat/rooms/d1d5373f-6d57-4fee-a9e5-e3f74ca2b9bf.jpg"
import room3 from "../../../store/Diplomat/rooms/03cb312c-18cc-4ffe-852c-c8ec9dab8a28.jpg"
import room4 from "../../../store/Diplomat/rooms/05154be6-3a70-4d90-a3f7-624eee3de87f.jpg"
import cnn from "../../../store/Vienna_new/Cnn_logo_red_background.png"
import Pics from "./Pics";
import Diplomat_meeting_map from "./Diplomat_meeting_map";

import pocasiJasno from "../../../store/pocasi/jasno.svg";
import pocasiMesic from "../../../store/pocasi/mesic.svg";
import pocasiPolojasno from "../../../store/pocasi/polojasno.svg";
import pocasiZatazeno from "../../../store/pocasi/zatazeno.svg";
import pocasiLehkyDest from "../../../store/pocasi/lehky_dest.svg";
import pocasiCloudRain from "../../../store/pocasi/cloud_rain.svg";
import pocasiBlesk from "../../../store/pocasi/blesk_s_destem.svg";
import pocasiSnezeni from "../../../store/pocasi/snezeni.svg";
import pocasiMlha from "../../../store/pocasi/mlha.svg";
import svcSightseeing from "../../../store/pocasi/sightseeing.svg";
import svcTaxi from "../../../store/pocasi/taxi.svg";
import svcBarber from "../../../store/pocasi/barber.svg";
import svcParking from "../../../store/pocasi/parking.svg";
import svcKadernictvi from "../../../store/pocasi/kadernictvi.svg";
import svcCarRental from "../../../store/pocasi/car-rental.svg";
import serviceTaxiPhoto from "../../../store/taxi.png";
import serviceBarberPhoto from "../../../store/barber.jpg";
import serviceParkingPhoto from "../../../store/parking.jpeg";
import serviceParkingPhoto2 from "../../../store/parking2.jpeg";
import serviceHairdresserPhoto from "../../../store/hairdresser.png";
import serviceCarRentalPhoto from "../../../store/car-rental.png";

/** Vrátí true, pokud se obrázek z URL skutečně načte (odfiltruje 404 z API). */
const imageUrlLoads = (url) =>
    new Promise((resolve) => {
        if (!url) return resolve(false);
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = url;
    });

const diplomatPragueLogoFallback = 'https://kiosk.csgcontrols.cz/api/admin/uploads/file-1773852147222-786461970.png';

// Diplomat webový art-deco: diamond pozadí + fotky z admin buildu
const adminMediaBaseUrl = `${path}/admin/static/media`;
const diamondSvgUrl = `${adminMediaBaseUrl}/diamond.svg`;
const diplomatIntroPhotoUrl = `${adminMediaBaseUrl}/2f529311-d03d-46a3-a5e1-01aecce4543b.ddcf6daf4e49addab219.jpg`;
// Diplomat admin groups:
// 40 = kiosk body slideshow
// 41 = kiosk footer slideshow
const kioskMainGroupId = 42;
const kioskFooterGroupId = 43;
// fallback groups (when primary groups don't exist / have no visible images)
const kioskMainGroupIdFallback = 47;
const kioskFooterGroupIdFallback = 48;
const loretaPhotoUrl = `${adminMediaBaseUrl}/Diplomat-Hotel-Prague-Restaurace-Praha-Loreta-02.webp`;
const hotelBarPhotoUrl = `${adminMediaBaseUrl}/Diplomat-Hotel-Prague-Bar-Praha-Hotel-Bar.webp`;
const bistroGrillPhotoUrl = `${adminMediaBaseUrl}/Diplomat-Hotel-Prague-Restaurace-Praha-Bistro-Grill-Diplomat-01.webp`;
const superiorRoomPhotoUrl = `${adminMediaBaseUrl}/Diplomat-Hotel-Prague-Hotel-Praha-Superior-Double-Room-02.webp`;
const bathroomRoomPhotoUrl = `${adminMediaBaseUrl}/Diplomat-Hotel-Prague-Hotel-Praha-Koupelna-Double-02.webp`;
const exterierPhotoUrl = `${adminMediaBaseUrl}/Diplomat-Hotel-Prague-Hotel-Praha-exterier-01-scaled.webp`;
const conferenceRoomsPhotoUrl = `${adminMediaBaseUrl}/Diplomat-Hotel-Prague-Konference-Praha-Konferencni-prostory-01.webp`;
const conferenceLoftPhotoUrl = `${adminMediaBaseUrl}/Diplomat-Hotel-Prague-Konference-Praha-Konferencni-prostory-Loft-01-2000x1334.webp`;
const bookingUrl = 'https://hoteldiplomat.book-onlinenow.net/index.aspx?Page=1&lan_id=cs-CZ';
const uploadsBaseUrl = `${path}/admin/uploads/`;

// Hotspoty v % vůči celému bitmapě `floorplan.png` (horní část = 2. patro, spodní = přízemí).
// leftPct/topPct = střed zóny, wPct/hPct = šířka/výška tap targetu.
const CONFERENCE_ROOMS = [
    { id: 'budapest', label: 'Budapest', leftPct: 8, topPct: 4, wPct: 15, hPct: 5.5, description: 'Conference room on 2nd floor, suitable for medium-sized meetings and presentations.' },
    { id: 'cracow', label: 'Cracow', leftPct: 9, topPct: 13, wPct: 15, hPct: 14, description: 'Flexible conference space ideal for workshops and training sessions.' },
    { id: 'sophia', label: 'Sophia', leftPct: 9, topPct: 23.5, wPct: 14, hPct: 7, description: 'Room with practical layout for board meetings and private events.' },
    { id: 'loreta', label: 'Loreta', leftPct: 22, topPct: 38, wPct: 44, hPct: 22, description: 'Large conference room for events, seminars and social gatherings.' },
    { id: 'belvedere', label: 'Belvedere', leftPct: 66, topPct: 43, wPct: 38, hPct: 15, description: 'Conference section with multiple room variants (I-VI), suited for larger events.' },
    { id: 'paris', label: 'Paris', leftPct: 90, topPct: 12.5, wPct: 9, hPct: 5, description: 'Smaller room for private meetings and interviews.' },
    { id: 'madrid', label: 'Madrid', leftPct: 90, topPct: 18, wPct: 9, hPct: 5, description: 'Bright conference room for workshops and business meetings.' },
    { id: 'rome', label: 'Rome', leftPct: 90, topPct: 24, wPct: 9, hPct: 5.5, description: 'Conference room suitable for presentations and team meetings.' },
    { id: 'berlin', label: 'Berlin', leftPct: 90, topPct: 30, wPct: 9, hPct: 5.5, description: 'Meeting room with quick access from foyer area.' },
    { id: 'london', label: 'London', leftPct: 90, topPct: 36, wPct: 9, hPct: 5.5, description: 'Compact room for smaller meetings and focused business sessions.' },
    { id: 'vienna', label: 'Vienna', leftPct: 78, topPct: 14, wPct: 12, hPct: 15, description: 'Conference space near Prague rooms, suitable for parallel sessions.' },
    { id: 'prague', label: 'Prague', leftPct: 49, topPct: 10.5, wPct: 40, hPct: 13, description: 'Main conference block (Prague A-D), ideal for larger corporate events.' },
];

const SIGHTSEEING_POINTS = [
    {
        id: 'hotel-diplomat',
        title: 'Hotel Diplomat Prague',
        leftPct: 40,
        topPct: 23,
        lat: 50.1008,
        lng: 14.3908,
        info: 'Your current location. Hotel Diplomat Prague is a great starting point for sightseeing, with quick access to Prague Castle, the historical center, and airport connections.',
        gallery: [
            `${uploadsBaseUrl}diplomat_prague.jpeg`,
            `${uploadsBaseUrl}diplomat_prague_2.jpg`,
            `${uploadsBaseUrl}diplomat_prague_3.webp`,
        ],
    },
    {
        id: 'castle',
        title: 'Prague Castle',
        leftPct: 33,
        topPct: 36,
        lat: 50.0909,
        lng: 14.4005,
        info: 'The largest ancient castle complex in the world, offering St. Vitus Cathedral, royal courtyards, and exceptional panoramic views over Prague. Ideal for a half-day visit with multiple monuments in one place.',
        gallery: [
            `${uploadsBaseUrl}prague_castle.jpeg`,
            `${uploadsBaseUrl}prague_castle_2.jpg`,
            `${uploadsBaseUrl}prague_catle_3.jpg`,
        ],
    },
    {
        id: 'charles-bridge',
        title: 'Charles Bridge',
        leftPct: 46,
        topPct: 46,
        lat: 50.0865,
        lng: 14.4114,
        info: 'Prague’s most iconic bridge lined with baroque statues, connecting Old Town and Lesser Town. Great for sunrise and sunset walks with river and skyline views.',
        gallery: [
            `${uploadsBaseUrl}charles_bridge.jpg`,
            `${uploadsBaseUrl}charles_bridge_2.jpg`,
            `${uploadsBaseUrl}charles_bridge_3.webp`,
        ],
    },
    {
        id: 'old-town-square',
        title: 'Old Town Square',
        leftPct: 56,
        topPct: 44,
        lat: 50.0870,
        lng: 14.4210,
        info: 'Historic city center with the Astronomical Clock, gothic churches, and traditional architecture. Perfect for exploring nearby streets, cafes, and local landmarks on foot.',
        gallery: [
            'https://upload.wikimedia.org/wikipedia/commons/8/8a/Old_Town_Square_Prague.jpg',
            'https://upload.wikimedia.org/wikipedia/commons/c/c7/Prague_-_Old_Town_Square.jpg',
        ],
    },
    {
        id: 'wenceslas',
        title: 'Wenceslas Square',
        leftPct: 63,
        topPct: 53,
        lat: 50.0811,
        lng: 14.4253,
        info: 'A major Prague boulevard with shops, restaurants, and city nightlife. A practical starting point for shopping, dining, and access to nearby museums.',
        gallery: [
            'https://upload.wikimedia.org/wikipedia/commons/a/ad/Prague_Wenceslas_Square.jpg',
            'https://upload.wikimedia.org/wikipedia/commons/1/1a/V%C3%A1clavsk%C3%A9_n%C3%A1m%C4%9Bst%C3%AD%2C_Praha.jpg',
        ],
    },
    {
        id: 'vysehrad',
        title: 'Vysehrad',
        leftPct: 64,
        topPct: 67,
        lat: 50.0641,
        lng: 14.4178,
        info: 'Historic fortress above the Vltava with quieter atmosphere, city walls, and scenic viewpoints. Recommended for guests seeking a calm walk away from busy tourist zones.',
        gallery: [
            'https://upload.wikimedia.org/wikipedia/commons/0/06/Vysehrad_Prague.jpg',
            'https://upload.wikimedia.org/wikipedia/commons/9/9d/Basilica_of_St._Peter_and_St._Paul%2C_Vysehrad.jpg',
        ],
    },
    {
        id: 'dancing-house',
        title: 'Dancing House',
        leftPct: 58,
        topPct: 62,
        lat: 50.0755,
        lng: 14.4140,
        info: 'Modern landmark on the riverfront, known for its unique architecture. A quick stop for design lovers, photos, and nearby riverside walks.',
        gallery: [
            'https://upload.wikimedia.org/wikipedia/commons/8/8a/Dancing_House_Prague.jpg',
            'https://upload.wikimedia.org/wikipedia/commons/f/f5/Tancici_dum%2C_Praha.jpg',
        ],
    },
    {
        id: 'petrin',
        title: 'Petrin Tower',
        leftPct: 37,
        topPct: 44,
        lat: 50.0835,
        lng: 14.3953,
        info: 'Observation tower inspired by Paris with broad city views, gardens, and park paths. Combine with nearby monastery and hillside strolls.',
        gallery: [
            'https://upload.wikimedia.org/wikipedia/commons/5/5f/Petrin_Tower_Prague.jpg',
            'https://upload.wikimedia.org/wikipedia/commons/a/a5/Petrin_lookout_tower.jpg',
        ],
    },
    {
        id: 'national-theatre',
        title: 'National Theatre',
        leftPct: 52,
        topPct: 55,
        lat: 50.0810,
        lng: 14.4139,
        info: 'Historic theatre and a symbol of Czech national culture. Elegant exterior, riverside location, and nearby old-town attractions.',
        gallery: [
            'https://upload.wikimedia.org/wikipedia/commons/1/16/N%C3%A1rodn%C3%AD_divadlo_v_Praze.jpg',
            'https://upload.wikimedia.org/wikipedia/commons/9/96/National_Theatre_Prague.jpg',
        ],
    },
    {
        id: 'jewish-quarter',
        title: 'Jewish Quarter',
        leftPct: 60,
        topPct: 39,
        lat: 50.0900,
        lng: 14.4186,
        info: 'Josefov district featuring synagogues, museums, and the Old Jewish Cemetery. Rich history and one of Prague’s most meaningful cultural areas.',
        gallery: [
            'https://upload.wikimedia.org/wikipedia/commons/3/3d/Old_New_Synagogue_Prague.jpg',
            'https://upload.wikimedia.org/wikipedia/commons/2/2f/Old_Jewish_Cemetery_Prague.jpg',
        ],
    },
    {
        id: 'powder-tower',
        title: 'Powder Tower',
        leftPct: 66,
        topPct: 46,
        lat: 50.0875,
        lng: 14.4270,
        info: 'Late gothic gate marking a historical entrance into Old Town. Excellent nearby architecture and easy walking route toward central squares.',
        gallery: [
            'https://upload.wikimedia.org/wikipedia/commons/e/e5/Powder_Tower_Prague.jpg',
            'https://upload.wikimedia.org/wikipedia/commons/1/1a/Praha%2C_Pra%C5%A1n%C3%A1_br%C3%A1na.jpg',
        ],
    },
    {
        id: 'letna-park',
        title: 'Letna Park',
        leftPct: 57,
        topPct: 28,
        lat: 50.0984,
        lng: 14.4221,
        info: 'Spacious park with one of Prague’s best viewpoints over bridges and skyline. Great for relaxed walks, outdoor breaks, and evening photography.',
        gallery: [
            'https://upload.wikimedia.org/wikipedia/commons/5/59/Letna_Park_Prague.jpg',
            'https://upload.wikimedia.org/wikipedia/commons/4/48/Prague_view_from_Letna.jpg',
        ],
    },
    {
        id: 'municipal-house',
        title: 'Municipal House',
        leftPct: 68,
        topPct: 47,
        lat: 50.0876,
        lng: 14.4296,
        info: 'Art Nouveau architectural jewel with concert halls, exhibitions, and ornate interiors. A great stop for culture, events, and guided visits.',
        gallery: [
            'https://upload.wikimedia.org/wikipedia/commons/9/90/Obecn%C3%AD_d%C5%AFm_Prague.jpg',
            'https://upload.wikimedia.org/wikipedia/commons/b/b8/Municipal_House_Prague.jpg',
        ],
    },
];

const KioskDiplomat = (props) => {
    const defaultDiplomatOrgId = 'AC44260C-8496-4F02-9ECA-2B19F3C32726';
    const debugHotspots = (() => {
        try {
            const sp = new URLSearchParams(window.location.search || '');
            const v = sp.get('debugHotspots');
            return v === '1' || v === 'true' || v === 'yes';
        } catch {
            return false;
        }
    })();
    const [backgrounds, setBackgrounds] = useState([]);
    const [currentIndexA, setCurrentIndexA] = useState(0);
    const [footerBackgrounds, setFooterBackgrounds] = useState([]);
    const [currentIndexFooter, setCurrentIndexFooter] = useState(0);
    const [resolvedKioskMainGroupId, setResolvedKioskMainGroupId] = useState(kioskMainGroupId);
    const [resolvedKioskFooterGroupId, setResolvedKioskFooterGroupId] = useState(kioskFooterGroupId);
    const [mainImagesReady, setMainImagesReady] = useState(false);
    const [footerImagesReady, setFooterImagesReady] = useState(false);
    const [footerDragOffset, setFooterDragOffset] = useState(0);
    const [isFooterDragging, setIsFooterDragging] = useState(false);
    const [isFooterSnapAnimating, setIsFooterSnapAnimating] = useState(false);
    const [footerTransitionEnabled, setFooterTransitionEnabled] = useState(true);
    const footerDragRef = useRef({ active: false, startX: 0, moved: false, deltaX: 0 });
    const footerViewportRef = useRef(null);
    const [actTime, setactTime] = useState("undefined");
    const [actDate, setactDate] = useState("undefined");
    const [roomName, setroomName] = useState(props.roomName);
    const [logoOrg, setLogoOrg] = useState(props.logoOrg);
    const [news1, setNews1] = useState();
    const [news2, setNews2] = useState();
    const [news, setNews] = useState([]);
    const [currentIndexnews, setCurrentIndexnews] = useState(0);

    const [newsData, setNewsData] = useState([]);
    // weatherNow/forecastDays jsou zajištěné níže (multi-day)

    const [footerShow, setfooterShow] = useState(2);
    const [bodyRes, setbodyRes] = useState(2);
    // Default: rovnou galerie (PICS) - aby slideshow obsahoval obrázky z DB
    // step 0 = hlavní menu (kruhy + pozadí), step 1..4 = submenu, step 5 = slideshow (Pics)
    const [step, setStep] = useState(0);
    const [group, setGroup] = useState(null);
    const [activeCategory, setActiveCategory] = useState('restaurant'); // restaurant/rooms/conferences/services
    const [slideGroups, setSlideGroups] = useState([]);
    const [, setFooterImgUrl] = useState(null);
    const [header, setHeader] = useState(true);
    // Rooms full-screen gallery overlay
    const [roomsGalleryOpen, setRoomsGalleryOpen] = useState(false);
    const [roomsGalleryGroupId, setRoomsGalleryGroupId] = useState(null);
    const [roomsGalleryTitle, setRoomsGalleryTitle] = useState('');
    const [roomsGalleryDescription, setRoomsGalleryDescription] = useState('');
    const [roomsGalleryThumbSrc, setRoomsGalleryThumbSrc] = useState(null);
    const [roomsPage, setRoomsPage] = useState(0);
    const [roomsGalleryFullscreenOpen, setRoomsGalleryFullscreenOpen] = useState(false);
    const [roomsGalleryFullscreenIndex, setRoomsGalleryFullscreenIndex] = useState(0);
    const [restaurantFullscreenOpen, setRestaurantFullscreenOpen] = useState(false);
    const [restaurantFullscreenSrc, setRestaurantFullscreenSrc] = useState('');

    // Services full-screen gallery overlay
    const [servicesGalleryOpen, setServicesGalleryOpen] = useState(false);
    const [servicesGalleryGroupId, setServicesGalleryGroupId] = useState(null);
    const [servicesGalleryTitle, setServicesGalleryTitle] = useState('');
    const [servicesGalleryHeroSrc, setServicesGalleryHeroSrc] = useState(null);
    const [servicesDetailImages, setServicesDetailImages] = useState([]);
    const [servicesDetailIndex, setServicesDetailIndex] = useState(0);
    const [servicesDetailFullscreenOpen, setServicesDetailFullscreenOpen] = useState(false);
    const [sightseeingMapOpen, setSightseeingMapOpen] = useState(false);
    const [selectedSightseeingId, setSelectedSightseeingId] = useState(null);
    const [sightseeingGalleryOpen, setSightseeingGalleryOpen] = useState(false);
    const [sightseeingGalleryIdx, setSightseeingGalleryIdx] = useState(0);
    const inactivityTimerRef = useRef(null);

    const SERVICE_ICON_SRC = {
        sightseeing: svcSightseeing,
        taxi: svcTaxi,
        hertz: svcCarRental,
        barber: svcBarber,
        parking: svcParking,
        hairdresser: svcKadernictvi,
    };

    const ServiceIcon = ({ type }) => {
        const src = SERVICE_ICON_SRC[type];
        if (src) {
            if (type === 'sightseeing') {
                return <img src={src} alt="" className={classes.pocasiServiceIconImgSightseeing} />;
            }
            return (
                <span
                    aria-hidden
                    className={classes.pocasiServiceIconImg}
                    style={{ WebkitMaskImage: `url(${src})`, maskImage: `url(${src})` }}
                />
            );
        }
        return null;
    };
    const [response_list, setresponse_list] = useState([]);
    const [deviceOrgId, setDeviceOrgId] = useState(null);
    const resolvedOrgId = deviceOrgId || props.org || defaultDiplomatOrgId;
    const [selectedConferenceRoomId, setSelectedConferenceRoomId] = useState(CONFERENCE_ROOMS[0].id);
    const [conferencesRoomModalOpen, setConferencesRoomModalOpen] = useState(false);
    const [conferencesRoomModalPos, setConferencesRoomModalPos] = useState(null);
    const conferencesPlanWrapRef = useRef(null);
    const conferencesPlanImageRef = useRef(null);
    const conferencesRoomModalRef = useRef(null);
    const [conferencesImageMetrics, setConferencesImageMetrics] = useState(null);
    const [conferencesGalleryFullscreenOpen, setConferencesGalleryFullscreenOpen] = useState(false);
    const [conferencesGalleryFullscreenIndex, setConferencesGalleryFullscreenIndex] = useState(0);

    const [orgLogoUrl, setOrgLogoUrl] = useState(null);

    const [weatherNow, setWeatherNow] = useState(null); // { tempC, iconCode, description }
    const [forecastDays, setForecastDays] = useState([]); // [{ label, dateText, min, max, iconCode }]

    const fetch_meetings = async (orgIdToUse) => {
        const dt = new Date
        const date = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}`
        const actTime = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}T${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}:${String(dt.getSeconds()).padStart(2, "0")}`;
        try {
            const orgID = orgIdToUse || props.org || defaultDiplomatOrgId;
            const response = await axios.get(`${path}/getRecordsNowV2?orgID=${encodeURIComponent(orgID)}&day=${encodeURIComponent(actTime)}`);
            setresponse_list(response.data)
            decision_handler(response.data)
        } catch (error) {
            console.log(error)
            setStep(0)
        }

    }

    const clamp = (v, min, max) => Math.min(Math.max(v, min), max);

    useLayoutEffect(() => {
        if (!conferencesRoomModalOpen) return;
        const wrapEl = conferencesPlanWrapRef.current;
        const modalEl = conferencesRoomModalRef.current;
        if (!wrapEl || !modalEl) return;

        const room = CONFERENCE_ROOMS.find((r) => r.id === selectedConferenceRoomId);
        if (!room) return;

        const wrapRect = wrapEl.getBoundingClientRect();
        const modalRect = modalEl.getBoundingClientRect();

        const hotspotX =
            conferencesImageMetrics
                ? conferencesImageMetrics.leftOffsetPx + (room.leftPct / 100) * conferencesImageMetrics.widthPx
                : (room.leftPct / 100) * wrapRect.width;
        const hotspotY =
            conferencesImageMetrics
                ? conferencesImageMetrics.topOffsetPx + (room.topPct / 100) * conferencesImageMetrics.heightPx
                : (room.topPct / 100) * wrapRect.height;

        const modalW = modalRect.width;
        const modalH = modalRect.height;

        const maxLeft = Math.max(0, wrapRect.width - modalW);
        const maxTop = Math.max(0, wrapRect.height - modalH);

        // Modal is positioned above the hotspot (similar to translateY(-110%)),
        // but we do it in pixels so it never leaves the wrap bounds.
        const desiredLeft = hotspotX - modalW / 2;
        const desiredTop = hotspotY - modalH * 1.1;

        const clampedLeft = clamp(desiredLeft, 0, maxLeft);
        const clampedTop = clamp(desiredTop, 0, maxTop);

        const arrowLeftPx = clamp(hotspotX - clampedLeft, 0, modalW);
        setConferencesRoomModalPos({ leftPx: clampedLeft, topPx: clampedTop, arrowLeftPx });
    }, [conferencesRoomModalOpen, selectedConferenceRoomId, conferencesImageMetrics]);

    // Keep hotspot positioning aligned with the actually rendered image ("object-fit: contain" creates letterboxing)
    useLayoutEffect(() => {
        const wrapEl = conferencesPlanWrapRef.current;
        const imgEl = conferencesPlanImageRef.current;
        if (!wrapEl || !imgEl) return;

        let raf = 0;
        const measure = () => {
            const wrapRect = wrapEl.getBoundingClientRect();
            const imgRect = imgEl.getBoundingClientRect();
            // If image is not laid out yet, avoid divisions by 0.
            if (wrapRect.width <= 0 || wrapRect.height <= 0 || imgRect.width <= 0 || imgRect.height <= 0) return;
            const leftOffsetPx = imgRect.left - wrapRect.left;
            const topOffsetPx = imgRect.top - wrapRect.top;
            setConferencesImageMetrics({
                leftOffsetPx,
                topOffsetPx,
                widthPx: imgRect.width,
                heightPx: imgRect.height,
            });
        };

        const scheduleMeasure = () => {
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(measure);
        };

        scheduleMeasure();
        const ro = new ResizeObserver(scheduleMeasure);
        ro.observe(wrapEl);

        return () => {
            cancelAnimationFrame(raf);
            ro.disconnect();
        };
    }, []);

    const decision_handler = (x) => {
        // Pozor: fetch meetingů běží opakovaně — nesmí přepisovat ruční navigaci (kruhy/submenu).
        // Dřívější `setStep(5)` při prázdném seznamu dělalo, že jakékoli kliknutí „nic nedělalo“.
        if (x.length != 0) {
            if (props.id == 1) {
                setStep(10);
            }
            if (props.id == 2) {
                setStep(11);
            }
        } else {
            // Jen zavřít meeting obrazovky, když už meetingy nejsou — jinak nechat aktuální step.
            setStep((s) => (s === 10 || s === 11 ? 0 : s));
        }
    };

    const changeStep_handler = (step) => {
        setStep(step);
    }
    const changeGroup_handler = (id) => {
        setGroup(id);
    }
    const reload_handler = () => {
        window.location.reload();
    };

    const backToMainMenu = () => {
        // In Services overlays (Sightseeing map / Services gallery), back should return to Services page,
        // not all the way to the main menu.
        if (step === 4 && (sightseeingMapOpen || servicesGalleryOpen)) {
            setSightseeingMapOpen(false);
            setSightseeingGalleryOpen(false);
            setServicesGalleryOpen(false);
            setServicesGalleryGroupId(null);
            setServicesGalleryTitle('');
            setServicesDetailImages([]);
            setServicesDetailIndex(0);
            setServicesDetailFullscreenOpen(false);
            setSelectedSightseeingId(null);
            setSightseeingGalleryIdx(0);
            setGroup(null);
            setActiveCategory('services');
            setStep(4);
            return;
        }
        setGroup(null);
        setFooterImgUrl(null);
        setStep(0);
    };

    // Services detail: fetch all images for selected service group and render as hero + thumbnails.
    useEffect(() => {
        if (!servicesGalleryOpen) return;
        if (servicesGalleryGroupId == null) return;
        if (sightseeingMapOpen) return;
        let cancelled = false;

        const run = async () => {
            try {
                const resp = await axios.get(
                    `${path}/getCardsV3?orgID=${encodeURIComponent(resolvedOrgId)}&group=${encodeURIComponent(servicesGalleryGroupId)}&onlyVisible=1`
                );
                if (cancelled) return;
                const urls = (Array.isArray(resp.data) ? resp.data : [])
                    .map((x) => x?.path ? (assetsBaseUrl + x.path) : null)
                    .filter(Boolean);
                const local = servicesLocalGalleryByTitle(servicesGalleryTitle);
                const merged = [...local, ...urls].filter(Boolean);
                const deduped = Array.from(new Set(merged));
                const checked = await Promise.all(
                    deduped.map(async (u) => ((await imageUrlLoads(u)) ? u : null))
                );
                const final = checked.filter(Boolean);
                if (cancelled) return;
                setServicesDetailImages(final);
                setServicesDetailIndex(0);
                setServicesDetailFullscreenOpen(false);
            } catch (e) {
                if (cancelled) return;
                console.error('[KioskDiplomat] services detail fetch failed:', e?.message || e);
                const localOnly = servicesLocalGalleryByTitle(servicesGalleryTitle);
                const okLocal = (await Promise.all(localOnly.map(async (u) => ((await imageUrlLoads(u)) ? u : null)))).filter(Boolean);
                setServicesDetailImages(okLocal);
                setServicesDetailIndex(0);
                setServicesDetailFullscreenOpen(false);
            }
        };

        run();
        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [servicesGalleryOpen, servicesGalleryGroupId, servicesGalleryTitle, sightseeingMapOpen, resolvedOrgId]);

    useEffect(() => {
        const INACTIVITY_MS = 2 * 60 * 1000; // 2 minutes

        const goToMainPage = () => {
            setGroup(null);
            setFooterImgUrl(null);
            setServicesGalleryOpen(false);
            setServicesGalleryGroupId(null);
            setServicesGalleryTitle('');
            setServicesDetailImages([]);
            setServicesDetailIndex(0);
            setServicesDetailFullscreenOpen(false);
            setSightseeingMapOpen(false);
            setSightseeingGalleryOpen(false);
            setSelectedSightseeingId(null);
            setSightseeingGalleryIdx(0);
            setActiveCategory('restaurant');
            setStep(0);
        };

        const resetInactivityTimer = () => {
            if (inactivityTimerRef.current) {
                window.clearTimeout(inactivityTimerRef.current);
            }
            inactivityTimerRef.current = window.setTimeout(goToMainPage, INACTIVITY_MS);
        };

        const events = ['pointerdown', 'touchstart', 'mousemove', 'keydown', 'wheel', 'scroll'];
        events.forEach((ev) => window.addEventListener(ev, resetInactivityTimer, { passive: true }));

        // Start timer immediately after load
        resetInactivityTimer();

        return () => {
            events.forEach((ev) => window.removeEventListener(ev, resetInactivityTimer));
            if (inactivityTimerRef.current) {
                window.clearTimeout(inactivityTimerRef.current);
            }
        };
    }, []);

    /** Obal submenu: průhledný pro pointer-events — aby šlo klikat i na kruhy vpravo (nad ním je vyšší z-index sideNav). */
    const submenuWrapper = (inner, { hideBackButton = false } = {}) => (
        <div className={classes.submenuContent}>
            <div className={classes.submenuInner}>
                <div
                    className={classes.menuBackbt}
                    onClick={backToMainMenu}
                    role="button"
                    tabIndex={0}
                    style={{ display: hideBackButton ? 'none' : 'flex' }}
                >
                    <span className={classes.menuBackIcon} aria-hidden="true" />
                </div>
                {inner}
            </div>
        </div>
    );

    const fetchNews = async () => {
        try {
            const response = await axios.get(`${path}/getNews`);
            const tmp = Array.isArray(response.data) ? response.data.map((x) => x?.description).filter(Boolean) : [];
            setNews(tmp);
            setCurrentIndexnews(0);
        } catch (e) {
            console.error('[KioskDiplomat] fetchNews failed:', e?.message || e);
            setNews([]);
        }
    };

    // const actTime = `${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}`;
    //const actDate = `${String(dt.getDate()).padStart(2, "0")}. ${String(dt.getMonth() + 1).padStart(2, "0")}. ${dt.getFullYear()}`;
    useEffect(() => {
        const apiKeyWea = '53aaf5c2175c0194becf66b6a9f26436';
        const city = 'Prague';
        const apiUrlForecast = `https://api.openweathermap.org/data/2.5/forecast?q=${encodeURIComponent(city)}&appid=${apiKeyWea}&units=metric`;

        const toYMD = (dtTxt) => String(dtTxt || '').split(' ')[0];
        const dayText = (ymd) => {
            const [y, m, d] = String(ymd || '').split('-');
            const mm = Number(m);
            const dd = Number(d);
            if (!Number.isFinite(mm) || !Number.isFinite(dd)) return '';
            return `${dd}.${mm}.`;
        };

            const computeForecast = (list) => {
            const byDay = new Map(); // ymd -> { temps: [], iconCode, description }
            for (const item of list) {
                const ymd = toYMD(item?.dt_txt);
                if (!ymd) continue;
                const t = Number(item?.main?.temp);
                if (!Number.isFinite(t)) continue;
                if (!byDay.has(ymd)) {
                    byDay.set(ymd, {
                        temps: [],
                        iconCode: item?.weather?.[0]?.icon || '01d',
                        description: item?.weather?.[0]?.description || '',
                    });
                }
                const d = byDay.get(ymd);
                d.temps.push(t);
                // preferuj icon z prvního dostupného záznamu pro daný den
                if (d.iconCode === '01d' && item?.weather?.[0]?.icon) d.iconCode = item.weather[0].icon;
                byDay.set(ymd, d);
            }

            const keys = Array.from(byDay.keys()).sort(); // yyyy-mm-dd
            const now = new Date();
            const todayYMD = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
            const todayIdx = keys.indexOf(todayYMD);
            const sliceStart = todayIdx >= 0 ? todayIdx : 0;
            const picked = keys.slice(sliceStart, sliceStart + 4);

            return picked.map((ymd, idx) => {
                const d = byDay.get(ymd);
                const min = Math.round(Math.min(...d.temps));
                const max = Math.round(Math.max(...d.temps));
                const label = idx === 0 ? 'Today' : '';
                return {
                    ymd,
                    label,
                    dateText: dayText(ymd),
                    min,
                    max,
                    iconCode: d.iconCode,
                    description: d.description,
                };
            });
        };

        const fetchForecast = async () => {
            try {
                const res = await fetch(apiUrlForecast);
                if (!res.ok) throw new Error('Failed to load forecast');
                const data = await res.json();
                const list = Array.isArray(data?.list) ? data.list : [];
                if (!list.length) return;

                const first = list[0];
                setWeatherNow({
                    tempC: Math.round(Number(first?.main?.temp)),
                    iconCode: first?.weather?.[0]?.icon || '01d',
                    description: first?.weather?.[0]?.description || '',
                });
                setForecastDays(computeForecast(list));
            } catch (e) {
                // Fallback so header doesn't disappear (e.g. invalid API key / blocked request).
                const now = new Date();
                const pad2 = (n) => String(n).padStart(2, '0');
                const toYMDInline = (dt) =>
                    `${dt.getFullYear()}-${pad2(dt.getMonth() + 1)}-${pad2(dt.getDate())}`;
                const ymd0 = toYMDInline(now);
                const d1 = new Date(now);
                d1.setDate(now.getDate() + 1);
                const d2 = new Date(now);
                d2.setDate(now.getDate() + 2);

                setWeatherNow({
                    tempC: 12,
                    iconCode: '01d',
                    description: 'clear sky',
                });

                // Match the 3-day header layout (Today + next 2).
                setForecastDays([
                    { ymd: ymd0, label: 'Today', dateText: dayText(ymd0), min: 1, max: 13, iconCode: '01d', description: 'clear sky' },
                    { ymd: toYMDInline(d1), label: '', dateText: dayText(toYMDInline(d1)), min: 0, max: 12, iconCode: '01d', description: 'clear sky' },
                    { ymd: toYMDInline(d2), label: '', dateText: dayText(toYMDInline(d2)), min: 4, max: 11, iconCode: '01d', description: 'clear sky' },
                    (() => {
                        const d3 = new Date(now);
                        d3.setDate(now.getDate() + 3);
                        return { ymd: toYMDInline(d3), label: '', dateText: dayText(toYMDInline(d3)), min: 3, max: 10, iconCode: '01d', description: 'clear sky' };
                    })(),
                ]);
            }
        };

        const updateMinute = () => {
            let dt = new Date
            //console.log(dt)
            setactTime(`${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}`)
            setactDate(`${String(dt.getDate()).padStart(2, "0")}. ${String(dt.getMonth() + 1).padStart(2, "0")}. ${dt.getFullYear()}`)
        };
        updateMinute()
        // Nastavení intervalu na 60 000 ms (1 minuta)
        const intervalId = setInterval(updateMinute, 1000);

        fetchForecast();
        const forecastIntervalId = setInterval(fetchForecast, 60 * 60 * 1000); // 1h
        // Cleanup funkce, která se spustí při unmountu komponenty
        return () => {
            clearInterval(intervalId);
            clearInterval(forecastIntervalId);
        };
    }, []);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentIndexA((prevIndex) => (prevIndex + 1) % backgrounds.length);
        }, 10000);
        return () => {
            clearInterval(intervalId);
        };
    }, [backgrounds]);

    useEffect(() => {
        let cancelled = false;
        const orgID = resolvedOrgId;
        setMainImagesReady(false);
        setFooterImagesReady(false);
        setResolvedKioskMainGroupId(kioskMainGroupId);
        setResolvedKioskFooterGroupId(kioskFooterGroupId);
        console.log('[KioskDiplomat] Footer slideshow init', {
            roomId: props.roomId,
            kioskId: props.id,
            deviceOrgId,
            orgFromUrl: props.org,
            resolvedOrgId: orgID,
            kioskMainGroupId,
            kioskMainGroupIdFallback,
            kioskFooterGroupId,
            kioskFooterGroupIdFallback,
        });

        const fetchGroupImages = async (groupId) => {
            try {
                const requestUrl = `${path}/getCardsV3?orgID=${encodeURIComponent(orgID)}&group=${encodeURIComponent(groupId)}&onlyVisible=1`;
                console.log('[KioskDiplomat] Fetch group images: request', { groupId, requestUrl });
                const r = await axios.get(requestUrl);
                const data = Array.isArray(r.data) ? r.data : [];
                const urls = data
                    .map((x) => x?.path)
                    .filter(Boolean)
                    .map((p) => `${assetsBaseUrl}${String(p).replace(/\\/g, '/')}`);
                console.log('[KioskDiplomat] Fetch group images: response', {
                    groupId,
                    cardsCount: data.length,
                    imageCount: urls.length,
                    sample: urls.slice(0, 3)
                });
                return urls;
            } catch (e) {
                console.error('[KioskDiplomat] Fetch group images failed', {
                    groupId,
                    orgID,
                    error: e?.message || e
                });
                return [];
            }
        };

        (async () => {
            const [mainPrimary, footerPrimary] = await Promise.all([
                fetchGroupImages(kioskMainGroupId),
                fetchGroupImages(kioskFooterGroupId),
            ]);

            // If primary groups are missing/empty, fallback to alternate groups.
            const mainUrls =
                mainPrimary.length
                    ? mainPrimary
                    : await fetchGroupImages(kioskMainGroupIdFallback);
            const footerUrls =
                footerPrimary.length
                    ? footerPrimary
                    : await fetchGroupImages(kioskFooterGroupIdFallback);

            if (cancelled) return;
            setResolvedKioskMainGroupId(mainPrimary.length ? kioskMainGroupId : kioskMainGroupIdFallback);
            setResolvedKioskFooterGroupId(footerPrimary.length ? kioskFooterGroupId : kioskFooterGroupIdFallback);
            setBackgrounds(mainUrls.length ? mainUrls : [diplomatIntroPhotoUrl]);
            setCurrentIndexA(0);
            setFooterBackgrounds(footerUrls.length ? footerUrls : [diplomatIntroPhotoUrl]);
            setCurrentIndexFooter(0);
            setMainImagesReady(true);
            setFooterImagesReady(true);
            console.log('[KioskDiplomat] Footer slideshow applied', {
                mainCount: mainUrls.length,
                footerCount: footerUrls.length,
                resolvedKioskMainGroupId: (mainPrimary.length ? kioskMainGroupId : kioskMainGroupIdFallback),
                resolvedKioskFooterGroupId: (footerPrimary.length ? kioskFooterGroupId : kioskFooterGroupIdFallback),
                footerActiveFirst: (footerUrls.length ? footerUrls : [diplomatIntroPhotoUrl])[0]
            });
        })();

        return () => {
            cancelled = true;
        };
    }, [deviceOrgId, props.org, resolvedOrgId]);

    const advanceFooterSlide = (delta) => {
        if (!footerBackgrounds.length) return;
        setCurrentIndexFooter((prev) => (prev + delta + footerBackgrounds.length) % footerBackgrounds.length);
    };

    const animateFooterSlide = (dir) => {
        if (!footerBackgrounds.length || footerBackgrounds.length <= 1) return;
        if (isFooterSnapAnimating) return;
        const width = footerViewportRef.current?.clientWidth || 0;
        const fullSlidePx = width || 1;
        setFooterTransitionEnabled(true);
        setIsFooterSnapAnimating(true);
        setFooterDragOffset(dir === 1 ? -fullSlidePx : fullSlidePx);
        window.setTimeout(() => {
            setCurrentIndexFooter((prev) => (prev + dir + footerBackgrounds.length) % footerBackgrounds.length);
            setFooterTransitionEnabled(false);
            setFooterDragOffset(0);
            window.requestAnimationFrame(() => {
                setFooterTransitionEnabled(true);
                setIsFooterSnapAnimating(false);
            });
        }, 320);
    };

    useEffect(() => {
        if (!footerBackgrounds.length || footerBackgrounds.length <= 1) return;
        const intervalId = setInterval(() => {
            // Auto rotace: stejný swipe efekt jako ruční gesture.
            animateFooterSlide(1);
        }, 10000);
        return () => {
            clearInterval(intervalId);
        };
    }, [footerBackgrounds, isFooterDragging, isFooterSnapAnimating]);

    const getFooterSlideByOffset = (offset) => {
        if (!footerImagesReady) return null;
        if (!footerBackgrounds.length) return backgrounds[currentIndexA] || diplomatIntroPhotoUrl;
        const idx = (currentIndexFooter + offset + footerBackgrounds.length) % footerBackgrounds.length;
        return footerBackgrounds[idx];
    };

    const handleFooterPointerDown = (e) => {
        if (footerBackgrounds.length <= 1 || isFooterSnapAnimating) return;
        footerDragRef.current = { active: true, startX: e.clientX, moved: false, deltaX: 0 };
        setIsFooterDragging(true);
        setFooterTransitionEnabled(false);
        setFooterDragOffset(0);
        if (e.currentTarget.setPointerCapture) e.currentTarget.setPointerCapture(e.pointerId);
    };

    const handleFooterPointerMove = (e) => {
        if (!footerDragRef.current.active) return;
        const dx = e.clientX - footerDragRef.current.startX;
        if (Math.abs(dx) > 3) footerDragRef.current.moved = true;
        footerDragRef.current.deltaX = dx;
        setFooterDragOffset(dx);
    };

    const handleFooterPointerEnd = (e) => {
        if (!footerDragRef.current.active) return;
        const dx = footerDragRef.current.deltaX;
        const width = e.currentTarget?.clientWidth || 0;
        setIsFooterDragging(false);
        // Nižší threshold, aby swipe byl přirozený i na menším footeru.
        const threshold = Math.max(24, Math.min(80, width * 0.06));
        if (Math.abs(dx) >= threshold) {
            const dir = dx < 0 ? 1 : -1;
            animateFooterSlide(dir);
        } else {
            // Nedostatečný drag -> plynulý návrat zpět na střed
            setFooterTransitionEnabled(true);
            setFooterDragOffset(0);
        }
        footerDragRef.current = { active: false, startX: 0, moved: false, deltaX: 0 };
        if (e.currentTarget.releasePointerCapture) {
            try { e.currentTarget.releasePointerCapture(e.pointerId); } catch (_) {}
        }
    };

    useEffect(() => {

        const hourDelay = 2 * 60 * 1000; // 1 hour in milliseconds
        const refreshPage = setTimeout(() => {
            window.location.reload();
        }, hourDelay);


        return () => {
            clearTimeout(refreshPage);
        };
    }, []);
    // Resolve orgID from device settings (so short URLs without orgID still work)
    useEffect(() => {
        const deviceId = props.roomId;
        if (!deviceId) return;
        let cancelled = false;
        (async () => {
            try {
                const r = await axios.get(`${path}/getDeviceSettings/${deviceId}`);
                if (cancelled) return;
                const org = r.data?.deviceOrgId;
                if (org) setDeviceOrgId(org);
            } catch (_) {
                // keep fallback orgId
            }
        })();
        return () => { cancelled = true; };
    }, [props.roomId]);

    useEffect(() => {
        // Meeting fetch až po případném načtení deviceOrgId (fallback zajistí i když to selže)
        fetch_meetings(resolvedOrgId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resolvedOrgId]);

    // Logo organizace pro hlavičku (podle zařízení)
    useEffect(() => {
        if (!resolvedOrgId) return;
        let cancelled = false;
        (async () => {
            try {
                const r = await axios.get(`${path}/getOrganization/${resolvedOrgId}`);
                const logoPath = Array.isArray(r.data) && r.data[0]?.logoPath ? r.data[0].logoPath : null;
                if (!cancelled) {
                    setOrgLogoUrl(logoPath ? `${assetsBaseUrl}${logoPath}?t=${Date.now()}` : null);
                }
            } catch (_) {
                // keep fallback
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [resolvedOrgId]);

    // Slide groups (cSlideGroup) - aby kiosk uměl točit fotky podle kategorií
    useEffect(() => {
        if (!resolvedOrgId) return;
        let cancelled = false;
        (async () => {
            try {
                const r = await axios.get(`${path}/getSlideGroup?orgID=${encodeURIComponent(resolvedOrgId)}`);
                if (cancelled) return;
                const next = Array.isArray(r.data) ? r.data : [];
                setSlideGroups(next);
                console.log('[KioskDiplomat] slideGroups loaded:', next.map(g => ({
                    groupId: g.groupId,
                    groupName: g.groupName
                })));
            } catch (_) {
                if (!cancelled) setSlideGroups([]);
            }
        })();
        return () => { cancelled = true; };
    }, [resolvedOrgId]);

    useEffect(() => {
        // News for CNN bar (rotating text)
        fetchNews();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!news.length) return;
        const intervalIdNews = setInterval(() => {
            setCurrentIndexnews((prev) => (prev + 1) % news.length);
        }, 15000);
        return () => clearInterval(intervalIdNews);
    }, [news.length]);

    const fallbackGroupIDs = [10, 11, 12, 13, 14, 15, 16];
    const normalizeGroupName = (s) => String(s || '').toLowerCase();

    // Pro Diplomat Prague chceme pro "Restaurant" menu přesné a stabilní pořadí.
    // Proto používáme exact match na groupName (case-insensitive) místo "prvního matchnutí keywordů",
    // které může vybrat špatný group pokud existují podobné názvy.
    const getExactGroupId = (exactGroupNameLower) => {
        const g = (slideGroups || []).find(
            (sg) => normalizeGroupName(sg?.groupName) === String(exactGroupNameLower || '').toLowerCase()
        );
        const id = Number(g?.groupId);
        return Number.isFinite(id) ? id : null;
    };

    const matchGroupIDs = (keywords) => (slideGroups || [])
        .filter((g) => keywords.some((k) => normalizeGroupName(g?.groupName).includes(k)))
        .map((g) => Number(g?.groupId))
        .filter((n) => Number.isFinite(n));

    const slideGroupAllIDs = (slideGroups || [])
        .map((g) => Number(g?.groupId))
        .filter((n) => Number.isFinite(n));

    // Když pro danou kategorii groupName nic nenajde, nevracejme tvrdě [10..16],
    // protože u Diplomat to může mít jiné IDs. Místo toho zobrazíme aspoň všechny slide groups.
    const baseFallbackGroupIDs = slideGroupAllIDs.length ? slideGroupAllIDs : fallbackGroupIDs;

    // Slide group IDs pro jednotlivé dlaždice v "Eat" a "Explore" menu.
    // V adminu se tyto groupName liší, proto hledáme podle klíčových slov v groupName.
    const groupLobbyBar = getExactGroupId('Lobby bar') ?? matchGroupIDs(['lobby bar', 'lobby'])[0] ?? null;
    const groupBullBonito = getExactGroupId('BULL-BONITO') ?? matchGroupIDs(['bull', 'bonito'])[0] ?? null;
    const groupKatsura = getExactGroupId('Restaurant KATSURA') ?? matchGroupIDs(['katsura'])[0] ?? null;
    const groupLoreta = getExactGroupId('Loreta restaurant') ?? matchGroupIDs(['loreta'])[0] ?? null;
    const groupRoofTerrace = getExactGroupId('Roof terrace') ?? matchGroupIDs(['roof', 'terrace'])[0] ?? null;
    const groupRoomService = getExactGroupId('Room service') ?? matchGroupIDs(['room service', 'roomservice'])[0] ?? null;
    const groupCatering = getExactGroupId('Catering') ?? matchGroupIDs(['catering'])[0] ?? null;

    const groupSightseeing = matchGroupIDs(['sightseeing'])[0] ?? null;
    const groupTaxi = matchGroupIDs(['taxi'])[0] ?? null;
    const groupHertz = matchGroupIDs(['hertz'])[0] ?? null;
    const groupHairdresser = matchGroupIDs(['hairdresser'])[0] ?? null;
    const groupBarber = matchGroupIDs(['barber'])[0] ?? null;
    const groupParking = matchGroupIDs(['parking'])[0] ?? null;
    const groupSimeaFlowers = matchGroupIDs(['simea'])[0] ?? null;
    const groupFyzioGroup = matchGroupIDs(['fyzi', 'fyzio', 'physio'])[0] ?? null;

    const servicesHeroByTitle = (title) => {
        const t = String(title || '').trim().toLowerCase();
        if (!t) return hotelBarPhotoUrl;
        if (t.includes('taxi')) return exterierPhotoUrl;
        if (t.includes('hertz') || t.includes('car')) return exterierPhotoUrl;
        if (t.includes('parking')) return exterierPhotoUrl;
        if (t.includes('hair') || t.includes('dresser') || t.includes('barber')) return hotelBarPhotoUrl;
        if (t.includes('room service')) return bistroGrillPhotoUrl;
        return hotelBarPhotoUrl;
    };

    const servicesLocalGalleryByTitle = (title) => {
        const t = String(title || '').trim().toLowerCase();
        if (t.includes('taxi')) return [serviceTaxiPhoto];
        if (t.includes('hertz') || t.includes('car rental') || t.includes('car-rental')) return [serviceCarRentalPhoto];
        if (t.includes('hairdresser') || t.includes('hair') || t.includes('dresser')) return [serviceHairdresserPhoto];
        if (t.includes('barber')) return [serviceBarberPhoto];
        if (t.includes('parking')) return [serviceParkingPhoto, serviceParkingPhoto2];
        return [];
    };

    const servicesInfoByTitle = (title) => {
        const t = String(title || '').trim().toLowerCase();
        if (t.includes('taxi')) return {
            subtitle: 'Fast and reliable city transport',
            body: 'Taxi service is available at the hotel reception. Our team helps with booking and recommended routes around Prague.',
        };
        if (t.includes('hertz')) return {
            subtitle: 'Car rental for business and leisure',
            body: 'Hertz rental service provides flexible mobility options for trips in Prague and across the Czech Republic.',
        };
        if (t.includes('hairdresser')) return {
            subtitle: 'Beauty and styling services',
            body: 'Professional hairdresser services for daily styling and special occasions are available near the hotel.',
        };
        if (t.includes('barber')) return {
            subtitle: 'Classic and modern men grooming',
            body: 'Barber service offers haircut and beard care in a comfortable setting with a focus on quality details.',
        };
        if (t.includes('parking')) return {
            subtitle: 'Convenient parking options',
            body: 'Hotel and nearby city parking options are available for guests. Reception can assist with navigation and availability.',
        };
        return {
            subtitle: 'Hotel guest services',
            body: 'Selected services are available for comfort during your stay. Contact reception for reservations and details.',
        };
    };

    const closeServicesDetailView = () => {
        setServicesGalleryOpen(false);
        setServicesGalleryGroupId(null);
        setServicesGalleryTitle('');
        setServicesGalleryHeroSrc(null);
        setServicesDetailImages([]);
        setServicesDetailIndex(0);
        setServicesDetailFullscreenOpen(false);
    };

    const removeBrokenServiceImage = (badSrc) => {
        setServicesDetailImages((prev) => {
            const removedIdx = prev.indexOf(badSrc);
            const next = prev.filter((u) => u !== badSrc);
            setServicesDetailIndex((i) => {
                if (next.length === 0) return 0;
                if (removedIdx === -1) return Math.min(i, next.length - 1);
                if (i > removedIdx) return i - 1;
                if (i === removedIdx) return Math.min(removedIdx, next.length - 1);
                return i;
            });
            return next;
        });
    };

    const openServicesByTitle = (title, gid) => {
        const nextGid = gid ?? baseFallbackGroupIDs[0] ?? 33;
        setSightseeingMapOpen(false);
        setServicesGalleryOpen(true);
        setServicesGalleryGroupId(nextGid);
        setServicesGalleryTitle(title);
        setServicesGalleryHeroSrc(servicesHeroByTitle(title));
        setServicesDetailIndex(0);
        setServicesDetailFullscreenOpen(false);
    };

    const renderServicesDetailNavGrid = (opts = {}) => {
        const sightseeingActive = opts.sightseeingActive === true;
        return (
            <div className={classes.servicesDetailNavGrid}>
                <button
                    type="button"
                    className={`${classes.servicesDetailNavBtn} ${classes.servicesDetailNavBtnBack}`}
                    onClick={closeServicesDetailView}
                >
                    Back to Services
                </button>
                <button
                    type="button"
                    className={`${classes.servicesDetailNavBtn} ${classes.servicesDetailNavBtnPrimary} ${sightseeingActive ? classes.servicesDetailNavBtnActive : ''}`}
                    onClick={() => {
                        closeServicesDetailView();
                        setSelectedSightseeingId(null);
                        setSightseeingGalleryIdx(0);
                        setSightseeingMapOpen(true);
                    }}
                >
                    <span className={classes.servicesDetailNavIcon}><ServiceIcon type="sightseeing" /></span>
                    <span className={classes.servicesDetailNavLabel}>Sightseeing</span>
                </button>
                {[
                    { title: 'Taxi', gid: groupTaxi, icon: 'taxi' },
                    { title: 'Hertz', gid: groupHertz, icon: 'hertz' },
                    { title: 'Hairdresser', gid: groupHairdresser, icon: 'hairdresser' },
                    { title: 'Barber', gid: groupBarber, icon: 'barber' },
                    { title: 'Parking', gid: groupParking, icon: 'parking' },
                ].map((it) => {
                    const isActive = !sightseeingActive && String(servicesGalleryTitle || '') === it.title;
                    return (
                        <button
                            key={`svc-nav-${it.title}`}
                            type="button"
                            className={`${classes.servicesDetailNavBtn} ${isActive ? classes.servicesDetailNavBtnActive : ''}`}
                            onClick={() => openServicesByTitle(it.title, it.gid)}
                        >
                            <span className={classes.servicesDetailNavIcon}><ServiceIcon type={it.icon} /></span>
                            <span className={classes.servicesDetailNavLabel}>{it.title}</span>
                        </button>
                    );
                })}
            </div>
        );
    };

    const restaurantGroupIDs = [
        groupLobbyBar,
        groupBullBonito,
        groupKatsura,
        groupLoreta,
        groupRoofTerrace,
        groupRoomService,
        groupCatering,
    ].filter((n) => Number.isFinite(n));

    const roomsGroupIDs = matchGroupIDs([
        'rooms',
        'suite',
        'junior suite',
        'superior room',
        'bathroom',
        'diplomat suite',
        'suite diplomat',
    ]);

    // Konkrétní groupy pro dlaždice na "Rooms" stránce (fallback když DB nemá očekávané názvy)
    const groupBathroomRoom = matchGroupIDs(['bathroom', 'koupelna'])[0] ?? null;
    const groupSuperiorRoom = matchGroupIDs(['superior room', 'superior', 'double room'])[0] ?? null;
    const groupExecutiveDoubleRoom = matchGroupIDs(['executive double', 'executive dbl'])[0] ?? matchGroupIDs(['executive'])[0] ?? null;
    const groupExecutiveTwinRoom = matchGroupIDs(['executive twin'])[0] ?? matchGroupIDs(['executive'])[0] ?? null;
    const groupSuperiorTripleRoom = matchGroupIDs(['superior triple', 'triple room', 'triple'])[0] ?? groupSuperiorRoom;
    const groupJuniorSuiteRoom = matchGroupIDs(['junior suite'])[0] ?? null;
    const groupFamilyJuniorSuiteRoom = matchGroupIDs(['family junior suite', 'family junior'])[0] ?? groupJuniorSuiteRoom;
    const groupDeluxeFamilyRoom = matchGroupIDs(['deluxe family', 'connecting', 'deluxe family (connecting)'])[0] ?? null;
    const groupDiplomatSuiteRoom = matchGroupIDs(['diplomat suite'])[0] ?? null;

    const conferencesGroupIDs = matchGroupIDs([
        'conferences',
        'conference',
        'meeting',
        'meet',
        'event',
        'events',
    ]);

    const groupConferenceMain = conferencesGroupIDs[0] ?? null;
    const groupConferenceLoft = matchGroupIDs(['loft'])[0] ?? null;

    const servicesGroupIDs = [
        groupSightseeing,
        groupTaxi,
        groupHertz,
        groupHairdresser,
        groupBarber,
        groupParking,
        groupSimeaFlowers,
        groupFyzioGroup,
    ].filter((n) => Number.isFinite(n));

    const activeGroupIDs = activeCategory === 'rooms'
        ? (roomsGroupIDs.length ? roomsGroupIDs : baseFallbackGroupIDs)
        : activeCategory === 'conferences'
            ? (conferencesGroupIDs.length ? conferencesGroupIDs : baseFallbackGroupIDs)
            : activeCategory === 'services'
                ? (servicesGroupIDs.length ? servicesGroupIDs : baseFallbackGroupIDs)
                : (restaurantGroupIDs.length ? restaurantGroupIDs : baseFallbackGroupIDs); // restaurant default

    const activeStartGroupID = activeGroupIDs[0] ?? null;

    // `group` používáme jen pro případ, že někdo klikne na konkrétní dlaždici v sub-menu.
    // Category taby (Eat/Sleep/Meet/Explore) nechávají `group=null`, a slideshow rotuje přes `activeGroupIDs`.
    useEffect(() => {
        // no-op
    }, []);

    useEffect(() => {
        console.log('[KioskDiplomat] activeCategory/groups:', {
            activeCategory,
            activeStartGroupID,
            activeGroupIDs
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeCategory, activeStartGroupID, JSON.stringify(activeGroupIDs)]);

    const activeNavStep =
        step === 0
            ? null
            : (step === 10 || step === 11)
                ? 3 // conferences/map
                : activeCategory === 'rooms'
                    ? 2
                    : activeCategory === 'conferences'
                        ? 3
                        : activeCategory === 'services'
                            ? 4
                            : 1; // restaurant default

    // V submenu módu (step 1..4) se mají posunout nahoru všechny 4 kruhy.
    const isSubmenuMode = step >= 1 && step <= 4;

    /** OpenWeather `icon` kódy (např. 01d, 10n) → lokální SVG z `store/pocasi`. */
    const WeatherSvg = ({ iconCode, size = 28 }) => {
        const code = String(iconCode || '').trim();
        const main = code.slice(0, 2);
        const night = code.endsWith('n');

        let src = pocasiMlha;
        if (main === '01') src = night ? pocasiMesic : pocasiJasno;
        else if (main === '02') src = pocasiPolojasno;
        else if (main === '03' || main === '04') src = pocasiZatazeno;
        else if (main === '09') src = pocasiLehkyDest;
        else if (main === '10') src = pocasiCloudRain;
        else if (main === '11') src = pocasiBlesk;
        else if (main === '13') src = pocasiSnezeni;
        else if (main === '50') src = pocasiMlha;

        return (
            <span
                aria-hidden
                className={classes.pocasiWeatherIconImg}
                style={{
                    width: size,
                    height: size,
                    WebkitMaskImage: `url(${src})`,
                    maskImage: `url(${src})`,
                }}
            />
        );
    };
    const footerBig = (
        <div className={classes.footer}>
            <div
                ref={footerViewportRef}
                className={`${classes.footerImage} ${isFooterDragging ? classes.footerImageDragging : ''}`}
                onPointerDown={handleFooterPointerDown}
                onPointerMove={handleFooterPointerMove}
                onPointerUp={handleFooterPointerEnd}
                onPointerCancel={handleFooterPointerEnd}
            >
                <div
                    className={classes.footerCarouselTrack}
                    style={{
                        // Track má šířku 300 %, takže pro "prostřední" slide je potřeba posun -33.333 %, ne -100 %.
                        transform: `translateX(calc(-33.333333% + ${footerDragOffset}px))`,
                        transition: (isFooterDragging || !footerTransitionEnabled) ? 'none' : 'transform 320ms ease'
                    }}
                >
                    <div className={classes.footerCarouselSlide}>
                        {footerImagesReady && <img src={getFooterSlideByOffset(-1)} alt="" />}
                    </div>
                    <div className={classes.footerCarouselSlide}>
                        {footerImagesReady && <img src={getFooterSlideByOffset(0)} alt="" />}
                    </div>
                    <div className={classes.footerCarouselSlide}>
                        {footerImagesReady && <img src={getFooterSlideByOffset(1)} alt="" />}
                    </div>
                </div>
    </div>

        </div>
    );

    const mainMenu_step = (
        <div className={classes.mainStep}>
            <div className={classes.mainMenuGrid}>
                <div className={classes.mainNavTile} onClick={() => changeStep_handler(1)} role="button" tabIndex={0}>
                    <img src={btn1} alt={""} className={classes.mainNavIcon} />
        </div>
                <div className={classes.mainNavTile} onClick={() => changeStep_handler(2)} role="button" tabIndex={0}>
                    <img src={btn2} alt={""} className={classes.mainNavIcon} />
    </div>
                <div className={classes.mainNavTile} onClick={() => changeStep_handler(3)} role="button" tabIndex={0}>
                    <img src={btn3} alt={""} className={classes.mainNavIcon} />
    </div>
                <div className={classes.mainNavTile} onClick={() => changeStep_handler(4)} role="button" tabIndex={0}>
                    <img src={btn4} alt={""} className={classes.mainNavIcon} />
                </div>
            </div>
        </div>
    );

    const restaurantMenu_step = (
        <div className={classes.restaurantWeb}>
            <img className={classes.restaurantDiamondPattern} src={diamondSvgUrl} alt="" />

            <div className={classes.restaurantStoryList}>
            
                <div className={`${classes.restaurantStoryRow} ${classes.restaurantStoryRowReverse}`}>
                    <button
                        type="button"
                        className={classes.restaurantStoryImageWrap}
                        onClick={() => {
                            setRestaurantFullscreenSrc(loretaPhotoUrl);
                            setRestaurantFullscreenOpen(true);
                        }}
                    >
                        <img className={classes.restaurantStoryImage} src={loretaPhotoUrl} alt="Diplomat Hotel Prague - Restaurace Praha - Loreta" />
                    </button>
                    <div className={classes.restaurantStoryText}>
                        <div className={classes.restaurantStoryTitle}>Loreta</div>
                        <div className={classes.restaurantStorySubtitle}>Snídaně, která udá tón celému dni</div>
                        <div className={classes.restaurantStoryBody}>
                            Den můžete začít v restauraci Loreta, kde vás čeká bohatá snídaně formou bufetu. Nabídka zahrnuje pestrý výběr teplých i studených pokrmů, živou kuchařskou show i bezlaktózové a bezlepkové varianty. Vše je připraveno s důrazem na kvalitu surovin a pohodlí hostů.
        </div>
                        <div className={classes.restaurantStoryHours}>
                            <div className={classes.restaurantStoryHoursLabel}>Otevírací doba:</div>
                            <div>Po–Pá: 6:30 – 10:30</div>
                            <div>So–Ne: 6:30 – 11:00</div>
                        </div>
                    </div>
                </div>

                <div className={classes.restaurantStoryRow}>
                    <button
                        type="button"
                        className={classes.restaurantStoryImageWrap}
                        onClick={() => {
                            setRestaurantFullscreenSrc(hotelBarPhotoUrl);
                            setRestaurantFullscreenOpen(true);
                        }}
                    >
                        <img className={classes.restaurantStoryImage} src={hotelBarPhotoUrl} alt="Diplomat Hotel Prague - Bar Praha - Hotel Bar" />
                    </button>
                    <div className={classes.restaurantStoryText}>
                        <div className={classes.restaurantStoryTitle}>Hotel Bar</div>
                        <div className={classes.restaurantStorySubtitle}>Klidné místo pro setkání i odpočinek</div>
                        <div className={classes.restaurantStoryBody}>
                            Stylový hotelový bar v art deco duchu je ideálním místem pro lehký oběd, odpolední šálek kávy nebo večerní sklenku vína. Uvolněná atmosféra, pohodlné sezení a krb vytvářejí prostor, kde můžete v klidu posedět, popovídat si nebo na chvíli zpomalit po dni stráveném v Praze.
                        </div>
                        <div className={classes.restaurantStoryHours}>
                            <div className={classes.restaurantStoryHoursLabel}>Otevírací doba:</div>
                            <div>Po–Pá: 8:00 – 00:00</div>
                            <div>So–Ne: 11:00 – 00:00</div>
                        </div>
                    </div>
                </div>

                <div className={`${classes.restaurantStoryRow} ${classes.restaurantStoryRowReverse}`}>
                    <button
                        type="button"
                        className={classes.restaurantStoryImageWrap}
                        onClick={() => {
                            setRestaurantFullscreenSrc(bistroGrillPhotoUrl);
                            setRestaurantFullscreenOpen(true);
                        }}
                    >
                        <img className={classes.restaurantStoryImage} src={bistroGrillPhotoUrl} alt="Bistro Grill Diplomat" />
                    </button>
                    <div className={classes.restaurantStoryText}>
                        <div className={classes.restaurantStoryTitle}>Bistro Grill Diplomat</div>
                        <div className={classes.restaurantStorySubtitle}>Moderní kuchyně pro náročné gurmány</div>
                        <div className={classes.restaurantStoryBody}>
                            Pro pracovní setkání, chutnou večeři nebo romantický večer je tu Bistro Grill Diplomat – elegantní restaurace s letní terasou. Přináší moderní bistro kuchyni s pokrmy z grilu a kultivovanou atmosférou. Kvalitní suroviny, promyšlené menu, profesionální servis a pečlivě sestavená nabídka vín, piv a koktejlů dotvářejí celkový zážitek.
                        </div>
                        <div className={classes.restaurantStoryHours}>
                            <div className={classes.restaurantStoryHoursLabel}>Otevírací doba:</div>
                            <div>Denně: 17:00 – 22:00</div>
                        </div>
                        <div className={classes.restaurantStoryActions}>
                            <a className={classes.restaurantStoryReserve} href="tel:+420296559138">
                                Rezervace +420 296 559 138
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            {restaurantFullscreenOpen && restaurantFullscreenSrc ? (
                <div
                    className={classes.roomsFullscreenOverlay}
                    onClick={() => setRestaurantFullscreenOpen(false)}
                >
                    <button
                        type="button"
                        className={classes.roomsFullscreenClose}
                        onClick={(e) => {
                            e.stopPropagation();
                            setRestaurantFullscreenOpen(false);
                        }}
                    >
                        Close
                    </button>
                    <img
                        className={`${classes.roomsFullscreenImg} ${classes.restaurantFullscreenImg}`}
                        src={restaurantFullscreenSrc}
                        alt=""
                        onClick={(e) => e.stopPropagation()}
                    />
                </div>
            ) : null}
        </div>
    );
    const otherMenu_step = (
        <div className={classes.restaurantWeb}>
            <img className={classes.restaurantDiamondPattern} src={diamondSvgUrl} alt="" />
            {!servicesGalleryOpen && !sightseeingMapOpen ? (
                <>
                    <div className={classes.roomsBanner}>
                        <img className={classes.roomsBannerImg} src={hotelBarPhotoUrl} alt="" />
                        <div className={classes.roomsBannerDiamond} />
                        <div className={classes.roomsBannerTitle}>Services</div>
                    </div>

                    <div className={classes.servicesThumbGrid}>
                        <div
                            className={classes.servicesModernCard}
                            role="button"
                            tabIndex={0}
                            onClick={() => {
                                setSelectedSightseeingId(null);
                                setSightseeingMapOpen(true);
                            }}
                        >
                            <div className={classes.servicesModernIcon}><ServiceIcon type="sightseeing" /></div>
                            <div className={classes.servicesModernTitle}>Sightseeing</div>
                            <div className={classes.servicesModernSub}>Interactive Prague map</div>
                            <div className={classes.servicesModernBtn}>OPEN MAP</div>
                        </div>

                        <div
                            className={classes.servicesModernCard}
                            role="button"
                            tabIndex={0}
                            onClick={() => {
                                const gid = groupTaxi ?? baseFallbackGroupIDs[0] ?? 33;
                                setServicesGalleryGroupId(gid);
                                setServicesGalleryTitle('Taxi');
                                setServicesGalleryHeroSrc(servicesHeroByTitle('Taxi'));
                                setServicesGalleryOpen(true);
                            }}
                        >
                            <div className={classes.servicesModernIcon}><ServiceIcon type="taxi" /></div>
                            <div className={classes.servicesModernTitle}>Taxi</div>
                            <div className={classes.servicesModernSub}>Transport services</div>
                            <div className={classes.servicesModernBtn}>VIEW MORE</div>
                        </div>

                        <div
                            className={classes.servicesModernCard}
                            role="button"
                            tabIndex={0}
                            onClick={() => {
                                const gid = groupHertz ?? baseFallbackGroupIDs[0] ?? 33;
                                setServicesGalleryGroupId(gid);
                                setServicesGalleryTitle('Hertz');
                                setServicesGalleryHeroSrc(servicesHeroByTitle('Hertz'));
                                setServicesGalleryOpen(true);
                            }}
                        >
                            <div className={classes.servicesModernIcon}><ServiceIcon type="hertz" /></div>
                            <div className={classes.servicesModernTitle}>Hertz</div>
                            <div className={classes.servicesModernSub}>Car rental</div>
                            <div className={classes.servicesModernBtn}>VIEW MORE</div>
                        </div>

                        <div
                            className={classes.servicesModernCard}
                            role="button"
                            tabIndex={0}
                            onClick={() => {
                                const gid = groupHairdresser ?? baseFallbackGroupIDs[0] ?? 33;
                                setServicesGalleryGroupId(gid);
                                setServicesGalleryTitle('Hairdresser');
                                setServicesGalleryHeroSrc(servicesHeroByTitle('Hairdresser'));
                                setServicesGalleryOpen(true);
                            }}
                        >
                            <div className={classes.servicesModernIcon}><ServiceIcon type="hairdresser" /></div>
                            <div className={classes.servicesModernTitle}>Hairdresser</div>
                            <div className={classes.servicesModernSub}>Beauty and styling</div>
                            <div className={classes.servicesModernBtn}>VIEW MORE</div>
                        </div>

                        <div
                            className={classes.servicesModernCard}
                            role="button"
                            tabIndex={0}
                            onClick={() => {
                                const gid = groupBarber ?? baseFallbackGroupIDs[0] ?? 33;
                                setServicesGalleryGroupId(gid);
                                setServicesGalleryTitle('Barber');
                                setServicesGalleryHeroSrc(servicesHeroByTitle('Barber'));
                                setServicesGalleryOpen(true);
                            }}
                        >
                            <div className={classes.servicesModernIcon}><ServiceIcon type="barber" /></div>
                            <div className={classes.servicesModernTitle}>Barber</div>
                            <div className={classes.servicesModernSub}>Men grooming</div>
                            <div className={classes.servicesModernBtn}>VIEW MORE</div>
                        </div>

                        <div
                            className={classes.servicesModernCard}
                            role="button"
                            tabIndex={0}
                            onClick={() => {
                                const gid = groupParking ?? baseFallbackGroupIDs[0] ?? 33;
                                setServicesGalleryGroupId(gid);
                                setServicesGalleryTitle('Parking');
                                setServicesGalleryHeroSrc(servicesHeroByTitle('Parking'));
                                setServicesGalleryOpen(true);
                            }}
                        >
                            <div className={classes.servicesModernIcon}><ServiceIcon type="parking" /></div>
                            <div className={classes.servicesModernTitle}>Parking</div>
                            <div className={classes.servicesModernSub}>Hotel and city parking</div>
                            <div className={classes.servicesModernBtn}>VIEW MORE</div>
            </div>
        </div>
    </>
            ) : sightseeingMapOpen ? (
                (() => {
                    const selectedSpot = selectedSightseeingId
                        ? (SIGHTSEEING_POINTS.find((s) => s.id === selectedSightseeingId) || null)
                        : null;
                    const gallery = selectedSpot && Array.isArray(selectedSpot.gallery) ? selectedSpot.gallery : [];
                    const gallerySrc = gallery.length > 0 ? gallery[sightseeingGalleryIdx % gallery.length] : null;
                    const mapCenter = selectedSpot ? [selectedSpot.lat, selectedSpot.lng] : [50.0833, 14.4167];
                    const mapZoom = selectedSpot ? 14 : 13;
                    return (
                        <div className={`${classes.servicesGalleryOverlay} ${classes.sightseeingModeOverlay}`}>
                            <div className={classes.servicesGalleryTopbar}>
                               
        </div>
                            <div className={classes.sightseeingMapLayout}>
                                <div className={classes.sightseeingMapWrap}>
                                    <MapContainer
                                        key={selectedSightseeingId || 'all'}
                                        center={mapCenter}
                                        zoom={mapZoom}
                                        className={classes.sightseeingLeafletMap}
                                        scrollWheelZoom={true}
                                    >
                                        <TileLayer
                                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                            attribution="&copy; OpenStreetMap contributors"
                                        />
                                        {SIGHTSEEING_POINTS.map((spot) => {
                                            const active = (selectedSightseeingId == null || spot.id === selectedSightseeingId);
                                            return (
                                                <CircleMarker
                                                    key={spot.id}
                                                    center={[spot.lat, spot.lng]}
                                                    radius={active ? 9 : 7}
                                                    pathOptions={{
                                                        color: active ? '#c1272d' : '#0f3d68',
                                                        fillColor: active ? '#c1272d' : '#0f3d68',
                                                        fillOpacity: 0.9,
                                                        weight: 2,
                                                    }}
                                                    eventHandlers={{
                                                        click: () => {
                                                            setSelectedSightseeingId(spot.id);
                                                            setSightseeingGalleryIdx(0);
                                                        },
                                                    }}
                                                >
                                                    <Tooltip
                                                        permanent
                                                        direction="top"
                                                        offset={[0, -10]}
                                                        className={classes.sightseeingLeafletLabel}
                                                    >
                                                        {spot.title}
                                                    </Tooltip>
                                                </CircleMarker>
                                            );
                                        })}
                                    </MapContainer>
            </div>
                                <div className={classes.sightseeingInfo}>
                                    <div className={classes.sightseeingPoiList}>
                                        <button
                                            type="button"
                                            className={`${classes.sightseeingPoiBtn} ${selectedSightseeingId == null ? classes.sightseeingPoiBtnActive : ''}`}
                                            onClick={() => {
                                                setSelectedSightseeingId(null);
                                                setSightseeingGalleryIdx(0);
                                            }}
                                        >
                                            All places
                                        </button>
                                        {SIGHTSEEING_POINTS.map((spot) => (
                                            <button
                                                key={spot.id}
                                                type="button"
                                                className={`${classes.sightseeingPoiBtn} ${spot.id === selectedSightseeingId ? classes.sightseeingPoiBtnActive : ''}`}
                                                onClick={() => {
                                                    setSelectedSightseeingId(spot.id);
                                                    setSightseeingGalleryIdx(0);
                                                }}
                                            >
                                                {spot.title}
                                            </button>
                                        ))}
        </div>
                                    {selectedSpot && (
                                        <div className={`${classes.sightseeingPoiCard} ${classes.sightseeingPoiCardActive}`}>
                                            <div className={classes.sightseeingPoiTitle}>{selectedSpot.title}</div>
                                            <div className={classes.sightseeingPoiDesc}>{selectedSpot.info}</div>
                                            <div className={classes.sightseeingPoiThumbs}>
                                                {(Array.isArray(selectedSpot.gallery) ? selectedSpot.gallery : []).slice(0, 3).map((img, idx) => (
                                                    <button
                                                        key={`${selectedSpot.id}-thumb-${idx}`}
                                                        type="button"
                                                        className={classes.sightseeingPoiThumbBtn}
                                                        onClick={() => {
                                                            setSightseeingGalleryIdx(idx);
                                                            setSightseeingGalleryOpen(true);
                                                        }}
                                                    >
                                                        <img className={classes.sightseeingPoiThumb} src={img} alt="" />
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {sightseeingGalleryOpen && (
                                <div className={classes.roomsFullscreenOverlay} onClick={() => setSightseeingGalleryOpen(false)}>
                                    <button
                                        type="button"
                                        className={classes.roomsFullscreenClose}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setSightseeingGalleryOpen(false);
                                        }}
                                    >
                                        Close
                                    </button>
                                    {gallery.length > 1 && (
                                        <>
                                            <button
                                                type="button"
                                                className={classes.roomsFullscreenNavLeft}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setSightseeingGalleryIdx((p) => (p - 1 + gallery.length) % gallery.length);
                                                }}
                                            >
                                                ‹
                                            </button>
                                            <button
                                                type="button"
                                                className={classes.roomsFullscreenNavRight}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setSightseeingGalleryIdx((p) => (p + 1) % gallery.length);
                                                }}
                                            >
                                                ›
                                            </button>
                                        </>
                                    )}
                                    {gallerySrc && (
                                        <img
                                            className={classes.roomsFullscreenImg}
                                            src={gallerySrc}
                                            alt=""
                                            onClick={(e) => e.stopPropagation()}
                                        />
                                    )}
        </div>
                            )}
                            <div className={classes.servicesBottomNavWrap}>
                                {renderServicesDetailNavGrid({ sightseeingActive: true })}
                            </div>
                </div>
                    );
                })()
            ) : (
                <div className={classes.servicesGalleryOverlay}>
                    <div className={classes.servicesGalleryTopbar}>
                        <button
                            type="button"
                            className={`${classes.servicesGalleryClose} ${classes.appleBackBtn} ${classes.appleBackBtnLight}`}
                            onClick={() => {
                                setServicesGalleryOpen(false);
                                setServicesGalleryGroupId(null);
                                setServicesGalleryTitle('');
                                setServicesDetailImages([]);
                                setServicesDetailIndex(0);
                                setServicesDetailFullscreenOpen(false);
                            }}
                        >
                        </button>
                        <div className={classes.servicesGalleryTitle}>{servicesGalleryTitle}</div>
                </div>

                    <div className={classes.servicesGalleryBody}>
                        {(() => {
                            const heroSrc =
                                servicesDetailImages?.[servicesDetailIndex] ||
                                servicesDetailImages?.[0] ||
                                null;

                            return (
                                <div className={classes.servicesDetailWrap}>
                                    <div className={classes.servicesDetailHero}>
                                        {heroSrc ? (
                                            <button
                                                type="button"
                                                className={classes.servicesDetailHeroBtn}
                                                onClick={() => setServicesDetailFullscreenOpen(true)}
                                            >
                                                <img
                                                    className={classes.servicesDetailHeroImg}
                                                    src={heroSrc}
                                                    alt=""
                                                    onError={() => removeBrokenServiceImage(heroSrc)}
                                                />
                                                <div className={classes.roomsWatermarkOnHero}>
                                                    <div className={classes.roomsWatermarkDiamond}>
                                                        <img src={diamondSvgUrl} alt="" />
                                                    </div>
                                                    <div className={classes.roomsWatermarkTitle}>{servicesGalleryTitle}</div>
                                                    <div
                                                        className={`${classes.roomsWatermarkDiamond} ${classes.roomsWatermarkDiamondRt}`}
                                                    >
                                                        <img src={diamondSvgUrl} alt="" />
                                                    </div>
                                                </div>
                                            </button>
                                        ) : (
                                            <div className={classes.servicesDetailHeroPlaceholder}>
                                                <CircularProgress color="inherit" size={64} />
                </div>
                                        )}
            </div>

                                    <div className={classes.servicesDetailInfo}>
                                        <div className={classes.servicesDetailInfoTitle}>{servicesGalleryTitle}</div>
                                        <div className={classes.servicesDetailInfoSubtitle}>
                                            {servicesInfoByTitle(servicesGalleryTitle).subtitle}
                                        </div>
                                        <div className={classes.servicesDetailInfoBody}>
                                            {servicesInfoByTitle(servicesGalleryTitle).body}
                                        </div>
                                    </div>

                                    <div className={classes.servicesDetailThumbs}>
                                        {servicesDetailImages.slice(0, 12).map((src, i) => (
                                            <button
                                                key={src}
                                                type="button"
                                                className={`${classes.servicesDetailThumbBtn} ${i === servicesDetailIndex ? classes.servicesDetailThumbBtnActive : ''}`}
                                                onClick={() => setServicesDetailIndex(i)}
                                            >
                                                <img
                                                    className={classes.servicesDetailThumbImg}
                                                    src={src}
                                                    alt=""
                                                    onError={() => removeBrokenServiceImage(src)}
                                                />
                                            </button>
                                        ))}
        </div>

                                    {servicesDetailFullscreenOpen && servicesDetailImages.length > 0 && (
                                        <div
                                            className={classes.roomsFullscreenOverlay}
                                            onClick={() => setServicesDetailFullscreenOpen(false)}
                                        >
                                            <button
                                                type="button"
                                                className={classes.roomsFullscreenClose}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setServicesDetailFullscreenOpen(false);
                                                }}
                                            >
                                                Close
                                            </button>
                                            {servicesDetailImages.length > 1 && (
                                                <>
                                                    <button
                                                        type="button"
                                                        className={classes.roomsFullscreenNavLeft}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setServicesDetailIndex((p) => (p - 1 + servicesDetailImages.length) % servicesDetailImages.length);
                                                        }}
                                                    >
                                                        ‹
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={classes.roomsFullscreenNavRight}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setServicesDetailIndex((p) => (p + 1) % servicesDetailImages.length);
                                                        }}
                                                    >
                                                        ›
                                                    </button>
                                                </>
                                            )}
                                            <img
                                                className={classes.roomsFullscreenImg}
                                                src={servicesDetailImages[servicesDetailIndex % servicesDetailImages.length]}
                                                alt=""
                                                onClick={(e) => e.stopPropagation()}
                                                onError={() =>
                                                    removeBrokenServiceImage(
                                                        servicesDetailImages[servicesDetailIndex % servicesDetailImages.length]
                                                    )
                                                }
                                            />
    </div>
                                    )}
        </div>
                            );
                        })()}
        </div>
                    <div className={classes.servicesBottomNavWrap}>
                        {renderServicesDetailNavGrid({ sightseeingActive: false })}
                    </div>
                </div>
            )}
        </div>
    );
    const roomsPerPage = 6;
    const roomsFallbackGroupId = baseFallbackGroupIDs?.[0] ?? 33;

    const toGroupId = (v) => {
        const n = Number(v);
        return Number.isFinite(n) ? n : roomsFallbackGroupId;
    };

    const resolveRoomGroupIdByTitle = (title, fallbackGroupId) => {
        const rawTitle = String(title || '').trim();
        if (!rawTitle) return fallbackGroupId;
        const stripped = rawTitle.replace(/\s*\(.*?\)\s*/g, '').trim();

        // 1) exact match (including/without trailing room numbers)
        const exact =
            getExactGroupId(stripped) ??
            getExactGroupId(rawTitle);
        if (exact != null) return exact;

        // 2) fuzzy scoring by tokens (so we can find e.g. "Superior Double Room" even if admin groupName differs slightly)
        const tokens = stripped
            .toLowerCase()
            .split(/[^a-z0-9]+/g)
            .filter((t) => t.length >= 3);
        if (!tokens.length) return fallbackGroupId;

        let bestId = fallbackGroupId;
        let bestScore = -1;
        for (const sg of slideGroups || []) {
            const name = normalizeGroupName(sg?.groupName);
            if (!name) continue;
            let score = 0;
            for (const tok of tokens) {
                if (name.includes(tok)) score++;
            }
            if (score > bestScore) {
                bestScore = score;
                const id = Number(sg?.groupId);
                if (Number.isFinite(id)) bestId = id;
            }
        }
        return bestScore >= 2 ? bestId : fallbackGroupId;
    };

    const roomsCardsAll = [
        {
            title: 'Superior Single Room',
            description:
                'A modern single room with a comfortable bed offers the ideal combination of comfort and practicality for a relaxing stay.',
            imgSrc: `${adminMediaBaseUrl}/Superior-Single-Room-2-832-scaled.webp`,
            groupId: toGroupId(groupSuperiorRoom),
        },
        {
            title: 'Superior Double Room',
            description:
                'A modern double room with a comfortable double bed offers the ideal combination of comfort and practicality for a relaxing stay.',
            imgSrc: superiorRoomPhotoUrl,
            groupId: toGroupId(groupSuperiorRoom),
        },
        {
            title: 'Superior Twin Room',
            description:
                'A modern twin room with separate comfortable beds offers the ideal combination of comfort and practicality for a relaxing stay.',
            imgSrc: superiorRoomPhotoUrl,
            groupId: toGroupId(groupSuperiorRoom),
        },
        {
            title: 'Superior Triple Room',
            description:
                'A modern triple room offers the ideal combination of comfort and practicality for your stay.',
            imgSrc: `${adminMediaBaseUrl}/Diplomat-Hotel-Prague-Hotel-Praha-Superior-Triple-Room-01-scaled.webp`,
            groupId: toGroupId(groupSuperiorTripleRoom),
        },
        {
            title: 'Executive Double Room',
            description:
                'An elegant Executive room in the upper floors, with sophisticated design, a comfortable double bed, and executive benefits for rest and work.',
            imgSrc: `${adminMediaBaseUrl}/Executive-Double-Room-scaled.webp`,
            groupId: toGroupId(groupExecutiveDoubleRoom),
        },
        {
            title: 'Executive Twin Room',
            description:
                'An elegant Executive room in the upper floors with sophisticated design, separate comfortable beds, and executive benefits for rest and work.',
            imgSrc: `${adminMediaBaseUrl}/Executive-Double-Room-scaled.webp`,
            groupId: toGroupId(groupExecutiveTwinRoom),
        },
        {
            title: 'Executive Double Room s výhledem na Pražský hrad',
            description:
                'Wake up every morning in a room with a view of one of Prague’s most beautiful landmarks.',
            imgSrc: `${adminMediaBaseUrl}/Executive-Double-Room-2-803-scaled.webp`,
            groupId: toGroupId(groupExecutiveDoubleRoom),
        },
       
        
        {
            title: 'Junior Suite ',
            description:
                'Space within one room is divided into two separate areas—one with a double bed and a relaxing seating area with an armchair.',
            imgSrc: diplomatIntroPhotoUrl,
            groupId: toGroupId(groupJuniorSuiteRoom),
        },

        {
            title: 'Family Junior Suite ',
            description:
                'Space within one room is divided into two separate areas—one with a double bed and a relaxing area with comfortable seating.',
            imgSrc: diplomatIntroPhotoUrl,
            groupId: toGroupId(groupFamilyJuniorSuiteRoom),
        },
        {
            title: 'Suite',
            description:
                'A 38 m² suite offers an ideal environment for guests looking for rest and work comfort.',
            imgSrc: diplomatIntroPhotoUrl,
            groupId: toGroupId(groupDiplomatSuiteRoom),
        },
        {
            title: 'Deluxe Family (Connecting) Room',
            description:
                'Deluxe Family (Connecting) Room je ideální pro rodiny nebo skupiny až 4 osob, které hledají pohodlí a soukromí.',
            imgSrc: diplomatIntroPhotoUrl,
            groupId: toGroupId(groupDeluxeFamilyRoom ?? groupDiplomatSuiteRoom),
        },
        {
            title: 'Bezbariérový pokoj',
            description:
                'An accessible room offers comfortable and safe accommodation for guests with limited mobility.',
            imgSrc: bathroomRoomPhotoUrl,
            groupId: toGroupId(groupBathroomRoom),
        },
        {
            title: 'Diplomat Suite 2',
            description:
                'A 58 m² Diplomat Suite offers an ideal setting for guests seeking a combination of relaxation and work comfort.',
            imgSrc: diplomatIntroPhotoUrl,
            groupId: toGroupId(groupDiplomatSuiteRoom),
        },
    ].map((card) => ({
        ...card,
        groupId: toGroupId(resolveRoomGroupIdByTitle(card.title, card.groupId)),
    }));

    const roomsCardsVisible = roomsCardsAll.slice(
        roomsPage * roomsPerPage,
        (roomsPage + 1) * roomsPerPage
    );
    const cleanRoomTitle = (title) =>
        String(title || '')
            .replace(/\s*\(\d+\)\s*$/g, '')
            .replace(/\s+\d+\s*$/g, '')
            .trim();

    const relatedRooms = roomsCardsAll.filter(
        (r) => cleanRoomTitle(r.title) !== cleanRoomTitle(roomsGalleryTitle)
    );

    const roomGalleryImagesFromTitle = (title) => {
        const raw = String(title || '').trim();
        const adminMedia = adminMediaBaseUrl;

        // Helper: normalize title to stable key
        const keyOf = (s) =>
            String(s || '')
                .toLowerCase()
                .replace(/\s*\(.*?\)\s*/g, ' ')
                .replace(/[^a-z0-9]+/g, ' ')
                .trim();

        // --- Explicit per-room mapping (3 images each) ---
        // If any filename differs, update here (all are under `${adminMediaBaseUrl}`).
        const ROOM_GALLERIES = {
            // IMPORTANT: Tohle mapování je 1:1 podle `roomsCardsAll` (1605–1699).
            // Každý pokoj má přesně 3 fotky a všechny URL jsou plné (přes `adminMediaBaseUrl`).

            // Superior rooms
            [keyOf('Superior Single Room')]: [
                `${adminMedia}/Superior-Single-Room-2-832-scaled.webp`,
                `${adminMedia}/Superior-Single-Room-2-832-scaled.webp`,
                `${adminMedia}/Superior-Single-Room-3-832-scaled.webp`,
            ],
            [keyOf('Superior Double Room')]: [
             `${adminMedia}/Executive-Double-Room-scaled.webp`,
            `${adminMedia}/Diplomat-Hotel-Prague-Hotel-Praha-Superior-Double-Room-02.webp`,
            `${adminMedia}/Diplomat-Hotel-Prague-Hotel-Praha-Koupelna-Double-02.webp`,
            ],
            [keyOf('Superior Twin Room')]:  [
                `${adminMedia}/Superior-Twin-Room-515-scaled.webp`,
               `${adminMedia}/Superior-Twin-Room-2-515-scaled.webp`,
               `${adminMedia}/Diplomat-Hotel-Prague-Hotel-Praha-Koupelna-Double-02.webp`,
               ],
            [keyOf('Superior Triple Room')]:  [
                `${adminMedia}/Diplomat-Hotel-Prague-Hotel-Praha-Superior-Triple-Room-01-scaled.webp`,
               `${adminMedia}/Diplomat-Hotel-Prague-Hotel-Praha-Superior-Triple-Room-02-scaled.webp`,
               `${adminMedia}/Diplomat-Hotel-Prague-Restaurace-Praha-Koupelna-01-scaled.webp`,
               ],

            // Executive rooms
            [keyOf('Executive Double Room')]: [
                `${adminMedia}/Diplomat-Hotel-Prague-Hotel-Praha-Executive-Double-Room-01.webp`,
                `${adminMedia}/Diplomat-Hotel-Prague-Hotel-Praha-Executive-Double-Room-02-scaled.webp`,
                `${adminMedia}/Diplomat-Hotel-Prague-Hotel-Praha-Koupelna-Double-02.webp`,
            ],
            [keyOf('Executive Twin Room')]: [
                `${adminMedia}/Diplomat-Hotel-Prague-Hotel-Praha-Executive-Twin-Room-01-scaled.webp`,
                `${adminMedia}/Superior-Twin-Room-2-515-scaled.webp`,
                `${adminMedia}/Diplomat-Hotel-Prague-Hotel-Praha-Koupelna-Double-02.webp`,
            ],
            [keyOf('Executive Double Room s výhledem na Pražský hrad')]: [
                `${adminMedia}/Executive-Double-Room-3-803-scaled.webp`,
                `${adminMedia}/Diplomat-Hotel-Prague-Hotel-Praha-Executive-Twin-Room-01-scaled.webp`,
                `${adminMedia}/Executive-Double-Room-2-803-scaled.webp`,
         
            ],

            // Suites / family
            [keyOf('Junior Suite')]:  [
                `${adminMedia}/Junior-Suite-3-522-scaled.webp`,
                `${adminMedia}/Junior-Suite-2-522-scaled.webp`,
                `${adminMedia}/Diplomat-Hotel-Prague-Restaurace-Praha-Koupelna-01-scaled.webp`,
         
            ],
            [keyOf('Family Junior Suite')]:  [
                `${adminMedia}/Family-Junior-Suite-822-scaled.webp`,
                `${adminMedia}/Diplomat-Hotel-Prague-Hotel-Praha-Family-Junior-Suite-01-scaled.webp`,
                `${adminMedia}/Diplomat-Hotel-Prague-Restaurace-Praha-Koupelna-01-scaled.webp`,
         
            ],
            [keyOf('Suite')]:  [
                `${adminMedia}/Diplomat-Hotel-Prague-Hotel-Praha-Senior-Suite-01-scaled.webp`,
                `${adminMedia}/Suite-Senior-Suite-4-841-scaled.webp`,
                `${adminMedia}/Diplomat-Hotel-Prague-Hotel-Praha-Senior-Suite-02-scaled.webp`,
         
            ],
            [keyOf('Deluxe Family (Connecting) Room')]:  [
                `${adminMedia}/Deluxe-Family-Connecting-Room-2-835-scaled.webp`,
                `${adminMedia}/Diplomat-Hotel-Prague-Hotel-Praha-Executive-Double-Room-01.webp`,
                `${adminMedia}/Diplomat-Hotel-Prague-Hotel-Praha-Koupelna-Double-02.webp`,
         
            ],

            // Accessible
            [keyOf('Bezbariérový pokoj')]:  [
                `${adminMedia}/Bezbarierovy-pokoj-03-scaled.webp`,
                `${adminMedia}/Bezbarierovy-pokoj-02.webp`,
                `${adminMedia}/Bezbarierovy-pokoj-scaled.webp`,
         
            ],

            // Diplomat suite
            [keyOf('Diplomat Suite')]:  [
                `${adminMedia}/Diplomat-Suite-2-861-scaled.webp`,
                `${adminMedia}/Diplomat-Suite-1-861-scaled.webp`,
                `${adminMedia}/Diplomat-Hotel-Prague-Hotel-Praha-Diplomat-Suite-01-scaled.webp`,
         
            ],
        };

        const key = keyOf(raw);

        // Try exact match first (including variants with room numbers)
        const direct = ROOM_GALLERIES[key];
        if (direct && direct.length) return direct.filter(Boolean);

        // Fallback: tolerate titles with trailing numbers like "Executive Double Room 3 (803)"
        // -> try removing standalone numbers tokens.
        const keyNoNums = key.replace(/\b\d+\b/g, '').replace(/\s+/g, ' ').trim();
        if (ROOM_GALLERIES[keyNoNums]?.length) return ROOM_GALLERIES[keyNoNums].filter(Boolean);

        // Last resort: previous generic fallback (still safe)
        return [exterierPhotoUrl, diplomatIntroPhotoUrl, conferenceRoomsPhotoUrl].filter(Boolean);
    };

    const roomDetailImages = roomGalleryImagesFromTitle(roomsGalleryTitle).slice(0, 3);
    // Aby se "main" fotka a list všech fotek chovaly stejně, bere main vždy první fotku ze seznamu.
    const roomsGalleryHeroSrc = roomDetailImages?.[0] || roomsGalleryThumbSrc;

    const roomsCanNext = (roomsPage + 1) * roomsPerPage < roomsCardsAll.length;
    const roomsCanPrev = roomsPage > 0;
    const roomsTotalPages = Math.max(1, Math.ceil(roomsCardsAll.length / roomsPerPage));
    const roomsIsSinglePage = roomsTotalPages <= 1;

    const rooms_step = (
        <div className={classes.restaurantWeb}>
            <img className={classes.restaurantDiamondPattern} src={diamondSvgUrl} alt="" />

            {!roomsGalleryOpen ? (
                <>
                    <div className={classes.roomsBanner}>
                        <img className={classes.roomsBannerImg} src={exterierPhotoUrl} alt="" />
                        <div className={classes.roomsBannerDiamond} />
                        <div className={classes.roomsBannerTitle}>Rooms</div>
                </div>

                    <div className={classes.roomsThumbGrid}>
                        {roomsCardsVisible.map((room) => (
                            <div
                                key={room.title}
                                className={classes.roomsThumbCard}
                                role="button"
                                tabIndex={0}
                                onClick={() => {
                                    setRoomsGalleryGroupId(room.groupId);
                                    setRoomsGalleryTitle(cleanRoomTitle(room.title));
                                    setRoomsGalleryDescription(room.description);
                                    setRoomsGalleryThumbSrc(room.imgSrc);
                                    setRoomsGalleryOpen(true);
                                }}
                            >
                                <img
                                    className={classes.roomsThumbImg}
                                    src={roomGalleryImagesFromTitle(cleanRoomTitle(room.title))?.[0] || room.imgSrc}
                                    alt=""
                                />
                                <div className={classes.roomsThumbTitle}>{cleanRoomTitle(room.title)}</div>
                                <div className={classes.roomsThumbText}>{room.description}</div>
                                <div
                                    className={classes.roomsThumbBtn}
                                    role="button"
                                    tabIndex={0}
                                >
                                    VIEW MORE
            </div>
        </div>
                        ))}
                    </div>

                    {(roomsCanPrev || roomsCanNext || roomsIsSinglePage) && (
                        <div className={classes.roomsPageNavRow}>
                            {(roomsCanPrev || roomsIsSinglePage) && (
                                <div
                                    className={classes.roomsPageNavBtn}
                                    role="button"
                                    tabIndex={0}
                                    onClick={() => setRoomsPage((p) => Math.max(0, p - 1))}
                                >
                                VIEW LESS
                                </div>
                            )}
                            {roomsCanNext && (
                                <div
                                    className={classes.roomsPageNavBtn}
                                    role="button"
                                    tabIndex={0}
                                    onClick={() => setRoomsPage((p) => p + 1)}
                                >
                                VIEW MORE
                                </div>
                            )}
                        </div>
                    )}
                </>
            ) : (
                <div className={classes.roomsGalleryOverlay}>
                    <div className={classes.roomsGalleryHero}>
                        {roomsGalleryHeroSrc ? (
                            <img className={classes.roomsGalleryHeroImg} src={roomsGalleryHeroSrc} alt="" />
                        ) : null}
                        <div className={classes.roomsWatermarkOnHero}>
                            <div className={classes.roomsWatermarkDiamond}>
                                <img src={diamondSvgUrl} alt="" />
        </div>
                            <div className={classes.roomsWatermarkTitle}>{roomsGalleryTitle}</div>
                            <div className={`${classes.roomsWatermarkDiamond} ${classes.roomsWatermarkDiamondRt}`}>
                                <img src={diamondSvgUrl} alt="" />
                            </div>
                        </div>
                    </div>

                    <button
                        type="button"
                        className={`${classes.roomsGalleryClose} ${classes.appleBackBtn} ${classes.appleBackBtnLight}`}
                        onClick={() => {
                            setRoomsGalleryOpen(false);
                            setRoomsGalleryGroupId(null);
                            setRoomsGalleryTitle('');
                            setRoomsGalleryDescription('');
                            setRoomsGalleryThumbSrc(null);
                            setRoomsGalleryFullscreenOpen(false);
                            setRoomsGalleryFullscreenIndex(0);
                        }}
                    >
                    </button>

                    <div className={classes.roomsGalleryDescArea}>
                        <div className={classes.roomsGalleryDetailDesc}>{roomsGalleryDescription}</div>
                        <div className={classes.roomsHeroFactsPanel}>
                            <div className={classes.roomsHeroFactsGrid}>
                                <ul className={classes.roomsHeroFactsCol}>
                                    <li className={classes.roomsHeroFactsItem}>Bezplatná vysokorychlostní Wi‑Fi</li>
                                    <li className={classes.roomsHeroFactsItem}>Satelitní TV s plochou obrazovkou</li>
                                    <li className={classes.roomsHeroFactsItem}>Psací stůl</li>
                                </ul>
                                <ul className={classes.roomsHeroFactsCol}>
                                    <li className={classes.roomsHeroFactsItem}>Safe / trezor</li>
                                    <li className={classes.roomsHeroFactsItem}>Fén</li>
                                    <li className={classes.roomsHeroFactsItem}>Set na přípravu kávy a čaje</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className={classes.roomsInlinePhotos}>
                        {roomDetailImages.map((src, i) => (
                            <button
                                key={`room-detail-${i}`}
                                type="button"
                                className={classes.roomsInlinePhotoBtn}
                                onClick={() => {
                                    setRoomsGalleryFullscreenIndex(i);
                                    setRoomsGalleryFullscreenOpen(true);
                                }}
                            >
                                <img className={classes.roomsInlinePhotoImg} src={src} alt="" />
                            </button>
                        ))}
                    </div>

                    {roomsGalleryFullscreenOpen && roomDetailImages.length > 0 && (
                        <div
                            className={classes.roomsFullscreenOverlay}
                            onClick={() => setRoomsGalleryFullscreenOpen(false)}
                        >
                            <button
                                type="button"
                                className={classes.roomsFullscreenClose}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setRoomsGalleryFullscreenOpen(false);
                                }}
                            >
                                Close
                            </button>
                            {roomDetailImages.length > 1 && (
                                <>
                                    <button
                                        type="button"
                                        className={classes.roomsFullscreenNavLeft}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setRoomsGalleryFullscreenIndex((p) => (p - 1 + roomDetailImages.length) % roomDetailImages.length);
                                        }}
                                    >
                                        ‹
                                    </button>
                                    <button
                                        type="button"
                                        className={classes.roomsFullscreenNavRight}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setRoomsGalleryFullscreenIndex((p) => (p + 1) % roomDetailImages.length);
                                        }}
                                    >
                                        ›
                                    </button>
                                </>
                            )}
                            <img
                                className={classes.roomsFullscreenImg}
                                src={roomDetailImages[roomsGalleryFullscreenIndex]}
                                alt=""
                                onClick={(e) => e.stopPropagation()}
                            />
                        </div>
                    )}
                    <div className={classes.roomsRelatedWrap}>
                        <div className={classes.roomsRelatedTitle}>Další typy pokojů</div>
                        <div className={classes.roomsRelatedGrid}>
                            {relatedRooms.map((room) => (
                                <div
                                    key={`related-${room.title}`}
                                    className={classes.roomsRelatedItem}
                                    role="button"
                                    tabIndex={0}
                                    onClick={() => {
                                        setRoomsGalleryGroupId(room.groupId);
                                        setRoomsGalleryTitle(cleanRoomTitle(room.title));
                                        setRoomsGalleryDescription(room.description);
                                        setRoomsGalleryThumbSrc(room.imgSrc);
                                        setRoomsGalleryOpen(true);
                                    }}
                                >
                                    {cleanRoomTitle(room.title)}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
    const meetings_step = (
        <div className={classes.restaurantWeb}>
            {(() => {
                const selectedRoom = CONFERENCE_ROOMS.find((r) => r.id === selectedConferenceRoomId) || CONFERENCE_ROOMS[0];
                const normalize = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
                const selectedNorm = normalize(selectedRoom.label);
                const roomMeetings = (Array.isArray(response_list) ? response_list : [])
                    .filter((m) => {
                        const roomTxt = normalize(m?.room);
                        if (!roomTxt) return false;
                        if (selectedNorm === 'belvedere') return roomTxt.includes('belvedere');
                        if (selectedNorm === 'prague') return roomTxt.includes('prague');
                        return roomTxt.includes(selectedNorm);
                    })
                    .sort((a, b) => String(a?.dateFrom || '').localeCompare(String(b?.dateFrom || '')));
                const now = Date.now();
                const activeMeeting = roomMeetings.find((m) => {
                    const from = Date.parse(m?.dateFrom);
                    const to = Date.parse(m?.dateTo);
                    if (!Number.isFinite(from) || !Number.isFinite(to)) return false;
                    return now >= from && now <= to;
                }) || null;
                const roomImage = activeMeeting?.path ? `${assetsBaseUrl}${String(activeMeeting.path).replace(/\\/g, '/')}` : null;
                const floorPlanSrc = conferenceFloorplan;
                const formatHm = (v) => {
                    if (!v) return '—';
                    const d = new Date(v);
                    if (Number.isNaN(d.getTime())) return String(v).substring(11, 16) || '—';
                    return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
                };

                return (
                    <div className={classes.conferencesPlanSection}>
                        <div className={classes.conferencesPlanLeft}>
                            <div className={classes.conferencesPlanWrap} ref={conferencesPlanWrapRef}>
                                <img
                                    className={classes.conferencesPlanImage}
                                    src={floorPlanSrc}
                                    alt="Floor plan"
                                    ref={conferencesPlanImageRef}
                                />
                                {CONFERENCE_ROOMS.map((room) => {
                                    const isSelected = room.id === selectedRoom.id;
                                    const xPx = conferencesImageMetrics
                                        ? conferencesImageMetrics.leftOffsetPx + (room.leftPct / 100) * conferencesImageMetrics.widthPx
                                        : null;
                                    const yPx = conferencesImageMetrics
                                        ? conferencesImageMetrics.topOffsetPx + (room.topPct / 100) * conferencesImageMetrics.heightPx
                                        : null;
                                    const wPx = conferencesImageMetrics && room.wPct
                                        ? (room.wPct / 100) * conferencesImageMetrics.widthPx
                                        : null;
                                    const hPx = conferencesImageMetrics && room.hPct
                                        ? (room.hPct / 100) * conferencesImageMetrics.heightPx
                                        : null;
                                    return (
                                        <button
                                            key={room.id}
                                            type="button"
                                            className={`${classes.conferencesHotspotHitArea} ${
                                                debugHotspots ? classes.conferencesHotspotHitAreaDebug : ''
                                            }`}
                                            style={{
                                                left:
                                                    xPx != null && wPx != null
                                                        ? `${xPx - wPx / 2}px`
                                                        : `${room.leftPct}%`,
                                                top:
                                                    yPx != null && hPx != null
                                                        ? `${yPx - hPx / 2}px`
                                                        : `${room.topPct}%`,
                                                width:
                                                    wPx != null
                                                        ? `${wPx}px`
                                                        : room.wPct
                                                            ? `${room.wPct}%`
                                                            : undefined,
                                                height:
                                                    hPx != null
                                                        ? `${hPx}px`
                                                        : room.hPct
                                                            ? `${room.hPct}%`
                                                            : undefined,
                                                // When we fall back to % positioning, we are using the *center point*.
                                                // For px positioning, we compute top-left already.
                                                transform: conferencesImageMetrics ? undefined : 'translate(-50%, -50%)',
                                            }}
                    onClick={() => {
                                                setSelectedConferenceRoomId(room.id);
                                                setConferencesRoomModalOpen(true);
                                            }}
                                            title={room.label}
                                        >
                                            {/* hidden label - hit area only */}
                                        </button>
                                    );
                                })}
                                {conferencesRoomModalOpen && (
                                    <div
                                        className={classes.conferencesRoomModal}
                                        ref={conferencesRoomModalRef}
                                        style={{
                                            left: conferencesRoomModalPos?.leftPx ?? 0,
                                            top: conferencesRoomModalPos?.topPx ?? 0,
                                        }}
                                    >
                                        <button
                                            type="button"
                                            className={classes.conferencesSideModalClose}
                                            aria-label="Close"
                                            onClick={() => setConferencesRoomModalOpen(false)}
                                        >
                                            ×
                                        </button>

                                        <div
                                            className={classes.conferencesRoomModalArrow}
                                            style={{ left: conferencesRoomModalPos?.arrowLeftPx ?? 0 }}
                                        />

                                        <div className={classes.conferencesDetailTitle}>{selectedRoom.label}</div>
                                        <div className={classes.conferencesDetailDesc}>{selectedRoom.description}</div>
                                        {(() => {
                                            const galleryImages = [
                                                roomImage,
                                                conferenceRoomsPhotoUrl,
                                                conferenceLoftPhotoUrl,
                                                exterierPhotoUrl,
                                            ].filter(Boolean);

                                            return (
                                                <>
                                                    {galleryImages.length > 0 && (
                                                        <div className={classes.conferencesGalleryRow}>
                                                            {galleryImages.slice(0, 4).map((src, i) => (
                                                                <button
                                                                    key={`conf-gallery-${selectedRoom.id}-${i}`}
                                                                    type="button"
                                                                    className={classes.conferencesGalleryThumbBtn}
                    onClick={() => {
                                                                        setConferencesGalleryFullscreenIndex(i);
                                                                        setConferencesGalleryFullscreenOpen(true);
                                                                    }}
                                                                >
                                                                    <img className={classes.conferencesGalleryThumbImg} src={src} alt="" />
                                                                </button>
                                                            ))}
                </div>
                                                    )}

                                                    {conferencesGalleryFullscreenOpen && galleryImages.length > 0 && (
                                                        <div
                                                            className={classes.conferencesFullscreenOverlay}
                                                            onClick={() => setConferencesGalleryFullscreenOpen(false)}
                                                        >
                                                            <button
                                                                type="button"
                                                                className={classes.conferencesFullscreenClose}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setConferencesGalleryFullscreenOpen(false);
                                                                }}
                                                            >
                                                                Close
                                                            </button>
                                                            {galleryImages.length > 1 && (
                                                                <>
                                                                    <button
                                                                        type="button"
                                                                        className={classes.conferencesFullscreenNavLeft}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            setConferencesGalleryFullscreenIndex((p) => (p - 1 + galleryImages.length) % galleryImages.length);
                                                                        }}
                                                                    >
                                                                        ‹
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        className={classes.conferencesFullscreenNavRight}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            setConferencesGalleryFullscreenIndex((p) => (p + 1) % galleryImages.length);
                                                                        }}
                                                                    >
                                                                        ›
                                                                    </button>
                                                                </>
                                                            )}
                                                            <img
                                                                className={classes.conferencesFullscreenImg}
                                                                src={galleryImages[conferencesGalleryFullscreenIndex]}
                                                                alt=""
                                                                onClick={(e) => e.stopPropagation()}
                                                            />
                </div>
                                                    )}
                                                </>
                                            );
                                        })()}
                                        <div className={classes.conferencesMeetingsTitle}>Planned meetings</div>
                                        <div className={classes.conferencesMeetingsList}>
                                            {roomMeetings.length === 0 && (
                                                <div className={classes.conferencesMeetingEmpty}>
                                                    No planned meetings for this room right now.
            </div>
                                            )}
                                            {roomMeetings.map((m) => {
                                                const isActive = activeMeeting && m.id === activeMeeting.id;
                                                return (
                                                    <div
                                                        key={`${selectedRoom.id}-${m.id}-${m.dateFrom}`}
                                                        className={`${classes.conferencesMeetingItem} ${isActive ? classes.conferencesMeetingItemActive : ''}`}
                                                    >
                                                        <div className={classes.conferencesMeetingTime}>
                                                            {formatHm(m.dateFrom)} - {formatHm(m.dateTo)}
                                                        </div>
                                                        <div className={classes.conferencesMeetingName}>{m.description || 'Meeting'}</div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                );
            })()}
        </div>
    );
    const meetingList_step = <>
        <div className={classes.meetingListMain}>
            <h1>Event List</h1>
            <div className={classes.listHeader}>
                <div className={classes.listHeader_time}>TIME</div>
                <div className={classes.listHeader_company}>COMPANY</div>
                <div className={classes.listHeader_name}>NAME</div>
                <div className={classes.listHeader_room}>ROOM</div>
                <div className={classes.listHeader_floor}>FLOOR</div>
            </div>
            {
response_list.length > 0 && response_list.map((x) => {
                    return <div key={x.id} className={classes.listRecord}>
                        <div className={classes.listHeader_time}>{x.dateFrom.substring(11,16)}</div>
                        <div className={classes.listHeader_company}>
                            <img src={assetsBaseUrl + x.path}/>
                        </div>
                        <div className={classes.listHeader_name}>{x.description}</div>
                        <div className={classes.listHeader_room}>{x.room}</div>
                        <div className={classes.listHeader_floor}>2</div>
                    </div>
                })
            }
        </div>
    </>
    const loader = <CircularProgress color="error" size={100}/>
    /*
    STEP
    0 = MAIN MENU
    1 = RESTAURANT MENU
    2 = ROOMS
    3 = MEETINGS
    5 = PICS DEF
    10 = Meeting > LIST
    11 = Meeting > MAP
    */

    return <div className={classes.main}>
        <img className={classes.globalDiamondPattern} src={diamondSvgUrl} alt="" />
        {header && (
            <div className={classes.header}>
                <div className={classes.headerInner}>
                    <div className={classes.brand}>
                        <img
                            src={orgLogoUrl || diplomatPragueLogoFallback || logo}
                            alt={"logo"}
                            className={classes.brandLogo}
                            onClick={reload_handler}
                        />
                </div>

                    <div className={classes.headerSep} />

                    <div className={classes.weatherBlock}>
                        {weatherNow ? (
                            <>
                                <div className={classes.weatherNowRow}>
                                    <div className={classes.weatherIcon}>
                                        <WeatherSvg iconCode={weatherNow.iconCode} size={44} />
                </div>
                                    <div className={classes.weatherTemp}>{weatherNow.tempC}°C</div>
                                </div>
                                <div className={classes.weatherDesc}>{weatherNow.description}</div>

                                <div className={classes.forecastRow}>
                                    {forecastDays.slice(0, 4).map((d) => (
                                        <div className={classes.forecastDay} key={d.ymd}>
                                            <div className={classes.forecastLabel}>{d.label || ""}</div>
                                            <div className={classes.forecastDate}>{d.dateText}</div>
                                            <div className={classes.forecastIcon}>
                                                <WeatherSvg iconCode={d.iconCode} size={34} />
                                            </div>
                                            <div className={classes.forecastTemps}>
                                                {d.min}°/{d.max}°
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </>
                        ) : (
                            <CircularProgress color="inherit" size={26} />
                        )}
                    </div>

                    <div className={classes.headerSep} />

                    <div className={classes.timeBlock}>
                    <div className={classes.timeA}>{actTime}</div>
                    <div className={classes.timeB}>{actDate}</div>
                </div>
            </div>
            </div>
        )}

        <div className={classes.body}>
            {step === 0 && (
                <div className={classes.cnnnews}>
                    <div className={classes.cnnIMG}><img src={cnn} alt=""/></div>
                    <div className={classes.cnnTXT}>
                        <label>{news.length > 0 && news[currentIndexnews]}</label>
                    </div>
                </div>
            )}
            {(step === 0 || step === 5) && (
                mainImagesReady && backgrounds.length > 0 && (
                <img
                        src={backgrounds[currentIndexA % backgrounds.length]}
                    alt=""
                    className={classes.mainBackground}
                />
                )
            )}
            <div className={classes.circle} />
            {!(step === 2 && roomsGalleryOpen) && (
            <div className={classes.sideNav}>
                <div
                    className={`${classes.sideNavCircle} ${classes.restaurantBT} ${isSubmenuMode ? classes.restaurantBTsubmenu : ""} ${activeNavStep === 1 ? classes.sideNavCircleActive : ""}`}
                    onClick={() => {
                        setActiveCategory('restaurant');
                        setGroup(null);
                        setFooterImgUrl(null);
                        setStep(1);
                    }}
                    role="button"
                    tabIndex={0}
                >
                    <span className={classes.sideNavLabel}>Restaurant</span>
                </div>
                <div
                    className={`${classes.sideNavCircle} ${classes.roomsBT} ${isSubmenuMode ? classes.roomsBTsubmenu : ""} ${activeNavStep === 2 ? classes.sideNavCircleActive : ""}`}
                    onClick={() => {
                        setActiveCategory('rooms');
                        setGroup(null);
                        setFooterImgUrl(null);
                        setRoomsPage(0);
                        setStep(2);
                    }}
                    role="button"
                    tabIndex={0}
                >
                    <span className={classes.sideNavLabel}>Rooms</span>
                </div>
                <div
                    className={`${classes.sideNavCircle} ${classes.conferencesBT} ${isSubmenuMode ? classes.conferencesBTsubmenu : ""} ${activeNavStep === 3 ? classes.sideNavCircleActive : ""}`}
                    onClick={() => {
                        setActiveCategory('conferences');
                        setGroup(null);
                        setFooterImgUrl(null);
                        setStep(3);
                    }}
                    role="button"
                    tabIndex={0}
                >
                    <span className={classes.sideNavLabel}>Conferences</span>
                </div>
                <div
                    className={`${classes.sideNavCircle} ${classes.servicesBT} ${isSubmenuMode ? classes.servicesBTsubmenu : ""} ${activeNavStep === 4 ? classes.sideNavCircleActive : ""}`}
                    onClick={() => {
                        setActiveCategory('services');
                        setGroup(null);
                        setFooterImgUrl(null);
                        setServicesGalleryOpen(false);
                        setServicesGalleryGroupId(null);
                        setServicesGalleryTitle('');
                        setSightseeingMapOpen(false);
                        setSightseeingGalleryOpen(false);
                        setSelectedSightseeingId(null);
                        setSightseeingGalleryIdx(0);
                        setStep(4);
                    }}
                    role="button"
                    tabIndex={0}
                >
                    <span className={classes.sideNavLabel}>Services</span>
                </div>
            </div>
            )}

            {step == 5 && (
                <div className={classes.slideshowFill}>
                    <div className={classes.slideshowWebShell}>
                        <img className={classes.restaurantDiamondPattern} src={diamondSvgUrl} alt="" />
                        <Pics
                            // If we are in “kiosk main slideshow” mode (no specific group selected),
                            // use group 40 (kiosk body) instead of category-based groups.
                            groupIDs={group != null ? [group] : (activeCategory === 'restaurant' ? [resolvedKioskMainGroupId] : activeGroupIDs)}
                            startGroupID={group != null ? group : (activeCategory === 'restaurant' ? resolvedKioskMainGroupId : activeStartGroupID)}
                            orgID={deviceOrgId}
                        />
                    </div>
                </div>
            )}
            {step == 1 && submenuWrapper(restaurantMenu_step)}
            {step == 2 && submenuWrapper(rooms_step, { hideBackButton: roomsGalleryOpen })}
            {step == 3 && submenuWrapper(meetings_step)}
            {step == 4 && submenuWrapper(otherMenu_step, { hideBackButton: false })}
            {step == 10 && meetingList_step}
            {step == 11 && <Diplomat_meeting_map orgID={deviceOrgId} />}
        </div>

        {(step === 0 || step === 5) && footerBig}

    </div>
}
export default KioskDiplomat